import React from 'react';

const AppIcons = {
  VideoIconMobile: ({ width = '24px', height = '24px' }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      version="1.1"
      viewBox="0 0 558.15 436.2"
      fill="#d8000d"
    >
      <g id="Layer_x0020_1">
        <metadata id="CorelCorpID_0Corel-Layer" />
        <path
          className="fil0"
          d="M37.24 0.02c57.84,0.13 274.27,-0.05 361.72,-0.01 28.3,0.02 47.91,20.73 47.91,52.38 -0.03,56.15 -0.11,77.26 -0,120.38 12.61,-11.7 106.39,-99.19 111.27,-103.71 -0.19,101.15 -0.38,203 0,303.24 -12.39,-12.08 -108.35,-101 -111.27,-103.77 -0.01,33.61 -0.01,77.36 -0.01,117.15 -0.01,47.13 -23.34,50.46 -61.5,50.49 -119.73,0.08 -230.1,-0.04 -349.52,-0.05 -24.35,-0.05 -35.86,-19.11 -35.85,-37.24 0,-118.8 0,-237.63 0,-356.43 0,-22.88 14.98,-42.32 37.24,-42.42zm151.76 111c-0.01,34.4 0.06,42.31 -0.01,76.57 -26.86,-0.03 -51.7,-0.01 -71.67,-0.02 -44.94,0.46 -45.97,64.2 0.02,64.92 34.17,0.04 37.3,0.04 71.66,0.02 0,33.25 0,46.87 0,80.12 -0.35,45.99 67.02,43.68 66.5,0 -0.23,-34.15 0.3,-45.54 -0.01,-80.12 26.91,-0.02 51.98,0.04 75.72,0.01 46.24,-0.47 43.79,-64.96 -0.11,-64.9 -26.6,-0.06 -60.48,-0.12 -75.64,-0.22 0.05,-31.99 0.04,-44.1 0.05,-76.38 0.69,-49.49 -66.29,-50.79 -66.5,0z"
        />
      </g>
    </svg>
  ),
  VideoIconToolbar: ({ width = '24px', height = '24px', fill }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      version="1.1"
      viewBox="0 0 558.15 365.4"
      fill={fill}
    >
      <g id="Layer_x0020_1">
        <metadata id="CorelCorpID_0Corel-Layer" />
        <path
          className="fil0"
          d="M37.24 0.02c57.84,0.12 274.27,-0.04 361.73,-0.01 28.3,0.02 47.91,19.42 47.91,49.07 -0.03,52.59 -0.11,48.79 -0,89.19 12.61,-10.97 106.39,-69.34 111.28,-73.57 -0.19,94.75 -0.38,166.58 0,260.48 -12.39,-11.32 -108.35,-94.61 -111.27,-97.2 -0.01,31.49 -0.01,52.84 -0.01,90.11 -0.01,44.15 -23.35,47.27 -61.5,47.29 -119.73,0.06 -230.1,-0.04 -349.52,-0.05 -24.35,-0.04 -35.87,-17.9 -35.85,-34.88 0,-111.29 0,-179.4 0,-290.69 0,-21.44 14.98,-39.64 37.24,-39.74zm151.76 88.26c-0.01,32.23 0.06,31.77 -0.01,63.87 -26.86,-0.03 -43.84,-0.01 -63.82,-0.02 -44.94,0.44 -45.97,60.14 0.02,60.82 34.17,0.04 29.44,0.04 63.81,0.02 0,31.15 0,36.05 0,67.2 -0.35,43.08 67.02,40.92 66.5,0 -0.23,-31.99 0.3,-34.81 -0.01,-67.21 26.91,-0.01 44.12,0.04 67.86,0.01 46.24,-0.44 43.79,-60.85 -0.11,-60.79 -26.6,-0.06 -52.62,-0.11 -67.79,-0.21 0.05,-29.97 0.04,-33.46 0.05,-63.69 0.69,-46.36 -66.29,-47.57 -66.5,0z"
        />
      </g>
    </svg>
  ),
  VideoIcon: ({ width, height }) => (
    <svg
      width={width ? width : '24'}
      height={height ? height : '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon/av/video_call_24px">
        <path
          id="icon/av/video_call_24px_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 7V10.5L19.29 8.2C19.92 7.57 21 8.02 21 8.91V15.08C21 15.97 19.92 16.42 19.29 15.79L17 13.5V17C17 17.55 16.55 18 16 18H4C3.45001 18 3 17.55 3 17V7C3 6.45 3.45001 6 4 6H16C16.55 6 17 6.45 17 7ZM11 13H13C13.55 13 14 12.55 14 12C14 11.45 13.55 11 13 11H11V9C11 8.45 10.55 8 10 8C9.45001 8 9 8.45 9 9V11H7C6.45001 11 6 11.45 6 12C6 12.55 6.45001 13 7 13H9V15C9 15.55 9.45001 16 10 16C10.55 16 11 15.55 11 15V13Z"
          fill="#e30813"
        />
      </g>
    </svg>
  ),
  DownloadIcon: ({
    width = '8px',
    height = '11px',
    fill = '#ffffff',
    onClick,
    className,
  }) => (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   version="1.1"
    //   viewBox="0 0 484.2 510.58"
    //   fill={fill}
    //   onClick={onClick}
    //   className={className}
    //   width={width}
    //   height={height}
    // >
    //   <g id="Layer_x0020_1">
    //     <metadata id="CorelCorpID_0Corel-Layer" />
    //     <path
    //       className="fil0"
    //       d="M60.53 510.58c-0.2,0 -0.42,0 -0.64,0 -15.85,0 -31.03,-6.46 -42.03,-17.85 -11.41,-11.01 -17.87,-26.18 -17.87,-42.04 0,-0.21 0,-0.43 0,-0.64 0,-30.26 0,-60.52 0,-90.79 0.15,-33.66 46.23,-34.28 46.17,0 0,29.59 0,59.19 0,88.78 -0.18,12.5 6.05,16.21 14.1,16.36l362.97 0c8.57,-0.18 14.76,-6.61 14.78,-16.92 0,-29.41 0,-58.81 0,-88.22 -0.04,-34.42 46.13,-33.31 46.17,0l0 90.79c0,33.42 -27.1,60.52 -60.52,60.52l-363.15 0zm159.48 -164.87c-38.79,-39.49 -77.57,-78.99 -116.35,-118.5 -26.7,-27.73 10.87,-62.98 39.08,-32.87l78.68 78.69 0 -246.64c0.52,-35.14 51.06,-35.21 50.95,0l0 246.64c26.23,-26.23 52.46,-52.46 78.68,-78.69 25.99,-27.19 62.97,5.51 35.95,35.92l-116.97 116.82 -3.82 3.82c-10.94,10.99 -27.53,12.61 -39.53,1.21 -2.02,-1.92 -4.29,-3.99 -6.66,-6.4z"
    //     />
    //   </g>
    // </svg>

    <svg
      fill={fill}
      onClick={onClick}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 11 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.40667 1.2713e-07C3.76167 1.2713e-07 3.22417 0.4925 3.1675 1.135C3.04986 2.47745 3.02007 3.82616 3.07834 5.1725L2.8675 5.1875L1.62584 5.2775C1.4445 5.29075 1.26971 5.35086 1.11858 5.45194C0.967452 5.55303 0.845161 5.69162 0.763681 5.85416C0.682201 6.0167 0.644324 6.19762 0.653758 6.37919C0.663193 6.56077 0.719615 6.73678 0.817502 6.89C1.73118 8.31977 2.9085 9.5627 4.28667 10.5525L4.78333 10.91C4.98002 11.0513 5.21612 11.1274 5.45834 11.1274C5.70055 11.1274 5.93665 11.0513 6.13334 10.91L6.63 10.5525C8.00789 9.56263 9.18492 8.31971 10.0983 6.89C10.1962 6.73678 10.2526 6.56077 10.2621 6.37919C10.2715 6.19762 10.2336 6.0167 10.1522 5.85416C10.0707 5.69162 9.94839 5.55303 9.79726 5.45194C9.64613 5.35086 9.47134 5.29075 9.29 5.2775L8.04834 5.1875C7.97835 5.18229 7.90835 5.17729 7.83834 5.1725C7.89667 3.82667 7.86667 2.4775 7.74917 1.135C7.72206 0.825088 7.57976 0.536597 7.35035 0.326472C7.12094 0.116348 6.8211 -0.000140474 6.51 1.2713e-07H4.40667ZM4.36 5.72083C4.26509 4.23135 4.28264 2.73684 4.4125 1.25H6.50417C6.63435 2.73682 6.65218 4.23133 6.5575 5.72083C6.55232 5.80341 6.56359 5.88619 6.59065 5.96438C6.61772 6.04256 6.66003 6.1146 6.71515 6.1763C6.77027 6.23801 6.83709 6.28816 6.91173 6.32384C6.98638 6.35952 7.06737 6.38003 7.15 6.38417C7.42 6.3975 7.68917 6.41417 7.95834 6.43417L8.85917 6.5C8.05905 7.67834 7.05764 8.70655 5.90084 9.5375L5.45917 9.855L5.01584 9.5375C3.85894 8.70632 2.85753 7.67782 2.0575 6.49917L2.95834 6.435C3.2275 6.415 3.4975 6.39833 3.76667 6.385C3.84937 6.38097 3.93045 6.36054 4.0052 6.3249C4.07994 6.28927 4.14686 6.23914 4.20206 6.17742C4.25727 6.1157 4.29966 6.04363 4.32677 5.96539C4.35388 5.88715 4.36518 5.80347 4.36 5.72083Z"
        // fill="white"
      />
    </svg>
  ),

  LocationIcon: ({
    width = '30px',
    height = '30px',
    fill = '#ffffff',
    onClick,
    className,
  }) => (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   viewBox="0 -960 960 960"
    //   fill={fill}
    //   onClick={onClick}
    //   className={className}
    //   width={width}
    //   height={height}
    // >
    //   <path d="M480.089-490Q509-490 529.5-510.589q20.5-20.588 20.5-49.5Q550-589 529.411-609.5q-20.588-20.5-49.5-20.5Q451-630 430.5-609.411q-20.5 20.588-20.5 49.5Q410-531 430.589-510.5q20.588 20.5 49.5 20.5ZM480-159q133-121 196.5-219.5T740-552q0-117.79-75.292-192.895Q589.417-820 480-820t-184.708 75.105Q220-669.79 220-552q0 75 65 173.5T480-159Zm0 79Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" />
    // </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
      onClick={onClick}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
    >
      <path
        d="M10 11.25C9.38194 11.25 8.77775 11.0667 8.26384 10.7233C7.74994 10.38 7.3494 9.89191 7.11288 9.32089C6.87635 8.74987 6.81447 8.12154 6.93505 7.51534C7.05563 6.90915 7.35325 6.35233 7.79029 5.91529C8.22733 5.47825 8.78415 5.18063 9.39034 5.06005C9.99654 4.93947 10.6249 5.00135 11.1959 5.23788C11.7669 5.4744 12.255 5.87494 12.5983 6.38884C12.9417 6.90275 13.125 7.50694 13.125 8.125C13.124 8.9535 12.7945 9.74778 12.2086 10.3336C11.6228 10.9195 10.8285 11.249 10 11.25ZM10 6.25C9.62916 6.25 9.26665 6.35997 8.95831 6.566C8.64997 6.77202 8.40964 7.06486 8.26773 7.40747C8.12581 7.75008 8.08868 8.12708 8.16103 8.4908C8.23338 8.85451 8.41195 9.1886 8.67418 9.45083C8.9364 9.71305 9.27049 9.89163 9.63421 9.96397C9.99792 10.0363 10.3749 9.99919 10.7175 9.85728C11.0601 9.71536 11.353 9.47504 11.559 9.1667C11.765 8.85835 11.875 8.49584 11.875 8.125C11.8745 7.62787 11.6768 7.15125 11.3253 6.79972C10.9738 6.4482 10.4971 6.2505 10 6.25Z"
        fill="white"
      />
      <path
        d="M10 18.75L4.72751 12.5319C4.65425 12.4385 4.58174 12.3445 4.51001 12.25C3.60937 11.0636 3.12282 9.61452 3.12501 8.125C3.12501 6.30164 3.84934 4.55295 5.13865 3.26364C6.42796 1.97433 8.17664 1.25 10 1.25C11.8234 1.25 13.5721 1.97433 14.8614 3.26364C16.1507 4.55295 16.875 6.30164 16.875 8.125C16.8772 9.61384 16.3909 11.0623 15.4906 12.2481L15.49 12.25C15.49 12.25 15.3025 12.4963 15.2744 12.5294L10 18.75ZM5.50751 11.4969C5.50876 11.4969 5.65376 11.6894 5.68688 11.7306L10 16.8175L14.3188 11.7237C14.3463 11.6894 14.4925 11.4956 14.4931 11.495C15.2289 10.5257 15.6265 9.34189 15.625 8.125C15.625 6.63316 15.0324 5.20242 13.9775 4.14752C12.9226 3.09263 11.4918 2.5 10 2.5C8.50816 2.5 7.07742 3.09263 6.02253 4.14752C4.96764 5.20242 4.37501 6.63316 4.37501 8.125C4.3737 9.34265 4.77112 10.5271 5.50751 11.4969Z"
        fill="white"
      />
    </svg>
  ),

  NotificationRingIcon: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon/social/notifications_none_24px">
        <path
          id="icon/social/notifications_none_24px_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.2901 17.04L18.0001 15.75V10.75C18.0001 7.67999 16.3602 5.10999 13.5001 4.42999V3.75C13.5001 2.92001 12.8302 2.25 12.0001 2.25C11.1702 2.25 10.5001 2.92001 10.5001 3.75V4.42999C7.63011 5.10999 6.00011 7.67001 6.00011 10.75V15.75L4.71019 17.04C4.08019 17.67 4.52013 18.75 5.41014 18.75H18.5802C19.4802 18.75 19.9202 17.67 19.2901 17.04ZM8.00011 16.75V10.75C8.00011 8.26999 9.51012 6.25 12.0001 6.25C14.4901 6.25 16.0001 8.26999 16.0001 10.75V16.75H8.00011ZM14.0001 19.75C14.0001 20.85 13.1001 21.75 12.0001 21.75C10.8901 21.75 10.0001 20.85 10.0001 19.75H14.0001Z"
          fill="#838383"
          fillOpacity="0.54"
        />
      </g>
    </svg>
  ),
  NavigationIcon: () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 4H4V0H0V4ZM6 16H10V12H6V16ZM4 16H0V12H4V16ZM0 10H4V6H0V10ZM10 10H6V6H10V10ZM12 0V4H16V0H12ZM10 4H6V0H10V4ZM12 10H16V6H12V10ZM16 16H12V12H16V16Z"
        fill="#838383"
        fillOpacity="0.54"
      />
    </svg>
  ),
  PictureIcon: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon/device/wallpaper_24px">
        <path
          id="icon/device/wallpaper_24px_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 4C4.45 4 4 4.45 4 5V10C4 10.55 3.55 11 3 11C2.45 11 2 10.55 2 10V4C2 2.89999 2.89999 2 4 2H10C10.55 2 11 2.45 11 3C11 3.55 10.55 4 10 4H5ZM6.65001 17.19L9.61 13.49C9.81001 13.24 10.19 13.24 10.39 13.49L12.97 16.71L14.6 14.53C14.8 14.26 15.2 14.26 15.4 14.53L17.4 17.2C17.65 17.53 17.41 18 17 18H7.04001C6.62001 18 6.39001 17.52 6.65001 17.19ZM17 8.5C17 7.67 16.33 7 15.5 7C14.67 7 14 7.67 14 8.5C14 9.33 14.67 10 15.5 10C16.33 10 17 9.33 17 8.5ZM14 2H20C21.1 2 22 2.89999 22 4V10C22 10.55 21.55 11 21 11C20.45 11 20 10.55 20 10V5C20 4.45 19.55 4 19 4H14C13.45 4 13 3.55 13 3C13 2.45 13.45 2 14 2ZM20 19C20 19.55 19.55 20 19 20H14C13.45 20 13 20.45 13 21C13 21.55 13.45 22 14 22H20C21.1 22 22 21.1 22 20V14C22 13.45 21.55 13 21 13C20.45 13 20 13.45 20 14V19ZM2 14C2 13.45 2.45 13 3 13C3.55 13 4 13.45 4 14V19C4 19.55 4.45 20 5 20H10C10.55 20 11 20.45 11 21C11 21.55 10.55 22 10 22H4C2.89999 22 2 21.1 2 20V14Z"
          fill="#838383"
          fillOpacity="0.54"
        />
      </g>
    </svg>
  ),
  LogoIcon: () => (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_129:2752)">
        <path
          d="M17.2184 3.84607C10.8683 3.84607 5.69873 8.73069 5.69873 14.7307C5.69873 20.7307 10.8276 25.6153 17.2184 25.6153C23.5685 25.6153 28.7381 20.7691 28.7381 14.7307C28.6974 8.73069 23.5685 3.84607 17.2184 3.84607ZM24.8303 15.8461L14.7761 20.8461C14.0841 21.1922 13.27 20.7307 13.27 19.9999V9.99992C13.27 9.26915 14.0841 8.80761 14.7761 9.15376L24.8303 14.1538C25.563 14.4999 25.563 15.4999 24.8303 15.8461Z"
          stroke="#E30D17"
          strokeMiterlimit="10"
        />
        <path
          d="M22.9172 18.4615L29.8371 21.923C27.232 26.6923 21.9403 29.923 15.8751 29.923C7.16413 29.923 0.12207 23.2307 0.12207 15C0.12207 6.7692 7.16413 0.115356 15.8751 0.115356C21.9403 0.115356 27.232 3.34613 29.8371 8.11536L22.9172 11.5769L13.7991 6.99997C12.8629 6.53843 11.7232 7.15382 11.7232 8.15382V21.8077C11.7232 22.8077 12.8629 23.4615 13.7991 22.9615L22.9172 18.4615Z"
          fill="#E30813"
          stroke="white"
          strokeWidth="0.5"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_129:2752">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  BurgerIcon: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 8C3.45 8 3 7.55 3 7C3 6.45 3.45 6 4 6H20C20.55 6 21 6.45 21 7C21 7.55 20.55 8 20 8H4ZM4 13H20C20.55 13 21 12.55 21 12C21 11.45 20.55 11 20 11H4C3.45 11 3 11.45 3 12C3 12.55 3.45 13 4 13ZM4 18H20C20.55 18 21 17.55 21 17C21 16.45 20.55 16 20 16H4C3.45 16 3 16.45 3 17C3 17.55 3.45 18 4 18Z"
        fill="#757575"
        fillOpacity="0.54"
      />
    </svg>
  ),
  SearchIcon: ({
    onClick,
    color = '#757575',
    height = '20',
    width = '20',
    opacity = '0.54',
    className,
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon/action/search_24px">
        <path
          id="icon/action/search_24px_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.1865 14.4716H15.9765L20.2165 18.7316C20.6265 19.1416 20.6265 19.8116 20.2165 20.2216C19.8065 20.6316 19.1365 20.6316 18.7265 20.2216L14.4765 15.9716V15.1816L14.2065 14.9016C12.8065 16.1016 10.8965 16.7216 8.86646 16.3816C6.08646 15.9116 3.86646 13.5916 3.52646 10.7916C3.00646 6.56157 6.56646 3.00157 10.7965 3.52157C13.5965 3.86157 15.9165 6.08157 16.3865 8.86157C16.7265 10.8916 16.1065 12.8016 14.9065 14.2016L15.1865 14.4716ZM5.47646 9.97157C5.47646 12.4616 7.48646 14.4716 9.97646 14.4716C12.4665 14.4716 14.4765 12.4616 14.4765 9.97157C14.4765 7.48157 12.4665 5.47157 9.97646 5.47157C7.48646 5.47157 5.47646 7.48157 5.47646 9.97157Z"
          fill={color}
          fillOpacity={opacity}
        />
      </g>
    </svg>
  ),
  SearchIconActive: ({
    onClick,
    color = '#434343',
    height = '24',
    width = '24',
    opacity = '1',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon/action/search_24px">
        <path
          id="icon/action/search_24px_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.1865 14.4716H15.9765L20.2165 18.7316C20.6265 19.1416 20.6265 19.8116 20.2165 20.2216C19.8065 20.6316 19.1365 20.6316 18.7265 20.2216L14.4765 15.9716V15.1816L14.2065 14.9016C12.8065 16.1016 10.8965 16.7216 8.86646 16.3816C6.08646 15.9116 3.86646 13.5916 3.52646 10.7916C3.00646 6.56157 6.56646 3.00157 10.7965 3.52157C13.5965 3.86157 15.9165 6.08157 16.3865 8.86157C16.7265 10.8916 16.1065 12.8016 14.9065 14.2016L15.1865 14.4716ZM5.47646 9.97157C5.47646 12.4616 7.48646 14.4716 9.97646 14.4716C12.4665 14.4716 14.4765 12.4616 14.4765 9.97157C14.4765 7.48157 12.4665 5.47157 9.97646 5.47157C7.48646 5.47157 5.47646 7.48157 5.47646 9.97157Z"
          fill={color}
          fillOpacity={opacity}
        />
      </g>
    </svg>
  ),
  HomeIcon: () => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.365 21.5H6.63502C5.64776 21.5366 4.68592 21.1822 3.95847 20.5138C3.23103 19.8453 2.79676 18.9168 2.75002 17.93V13.25C2.75002 13.051 2.82903 12.8603 2.96969 12.7196C3.11034 12.579 3.3011 12.5 3.50002 12.5C3.69893 12.5 3.88969 12.579 4.03035 12.7196C4.171 12.8603 4.25002 13.051 4.25002 13.25V17.93C4.29611 18.519 4.57209 19.0664 5.01835 19.4537C5.4646 19.841 6.0453 20.0372 6.63502 20H15.365C15.9547 20.0372 16.5354 19.841 16.9817 19.4537C17.4279 19.0664 17.7039 18.519 17.75 17.93V13.25C17.75 13.051 17.829 12.8603 17.9697 12.7196C18.1103 12.579 18.3011 12.5 18.5 12.5C18.6989 12.5 18.8897 12.579 19.0303 12.7196C19.171 12.8603 19.25 13.051 19.25 13.25V17.93C19.2033 18.9168 18.769 19.8453 18.0416 20.5138C17.3141 21.1822 16.3523 21.5366 15.365 21.5ZM21.2825 11.5325C21.3528 11.4627 21.4086 11.3798 21.4467 11.2884C21.4848 11.197 21.5044 11.099 21.5044 11C21.5044 10.9009 21.4848 10.8029 21.4467 10.7115C21.4086 10.6201 21.3528 10.5372 21.2825 10.4675L11.5325 0.717454C11.4628 0.647158 11.3798 0.591362 11.2884 0.553286C11.1971 0.515209 11.099 0.495605 11 0.495605C10.901 0.495605 10.803 0.515209 10.7116 0.553286C10.6202 0.591362 10.5372 0.647158 10.4675 0.717454L0.717517 10.4675C0.576289 10.6087 0.496948 10.8002 0.496948 11C0.496948 11.1997 0.576289 11.3912 0.717517 11.5325C0.858745 11.6737 1.05029 11.753 1.25002 11.753C1.44974 11.753 1.64129 11.6737 1.78252 11.5325L11 2.30745L20.2175 11.5325C20.2872 11.6027 20.3702 11.6585 20.4616 11.6966C20.553 11.7347 20.651 11.7543 20.75 11.7543C20.849 11.7543 20.9471 11.7347 21.0384 11.6966C21.1298 11.6585 21.2128 11.6027 21.2825 11.5325Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M2.60002 17.93H2.59985L2.60019 17.9371C2.64879 18.9634 3.10044 19.929 3.85698 20.6242C4.61283 21.3188 5.61202 21.6873 6.63778 21.65H15.3622C16.388 21.6873 17.3872 21.3188 18.1431 20.6242C18.8996 19.929 19.3512 18.9634 19.3998 17.9371L19.4 17.9371V17.93V13.25C19.4 13.0113 19.3052 12.7823 19.1364 12.6136C18.9676 12.4448 18.7387 12.35 18.5 12.35C18.2613 12.35 18.0324 12.4448 17.8636 12.6136C17.6948 12.7823 17.6 13.0113 17.6 13.25V17.924C17.5557 18.4716 17.2984 18.9802 16.8834 19.3404C16.4669 19.7019 15.9249 19.885 15.3745 19.8503L15.3745 19.85H15.365H6.63502V19.8497L6.62556 19.8503C6.07516 19.885 5.53317 19.7019 5.11667 19.3404C4.70162 18.9802 4.44438 18.4716 4.40002 17.924V13.25C4.40002 13.0113 4.3052 12.7823 4.13641 12.6136C3.96763 12.4448 3.73871 12.35 3.50002 12.35C3.26132 12.35 3.0324 12.4448 2.86362 12.6136C2.69484 12.7823 2.60002 13.0113 2.60002 13.25V17.93ZM1.88858 11.6385L1.88863 11.6385L11 2.51967L20.111 11.6381C20.1111 11.6382 20.1112 11.6382 20.1112 11.6383C20.1949 11.7226 20.2943 11.7894 20.4039 11.8351C20.5136 11.8808 20.6312 11.9043 20.75 11.9043C20.8688 11.9043 20.9865 11.8808 21.0961 11.8351C21.2056 11.7895 21.305 11.7227 21.3886 11.6385C21.4727 11.5549 21.5395 11.4556 21.5851 11.3461C21.6308 11.2364 21.6544 11.1188 21.6544 11C21.6544 10.8811 21.6308 10.7635 21.5851 10.6538C21.5395 10.5442 21.4726 10.4447 21.3883 10.3611C21.3882 10.361 21.3882 10.361 21.3881 10.361L11.639 0.611823C11.639 0.611774 11.6389 0.611725 11.6389 0.611677C11.5552 0.527391 11.4557 0.460487 11.3461 0.414822C11.2365 0.36913 11.1188 0.345605 11 0.345605C10.8812 0.345605 10.7636 0.36913 10.6539 0.414822C10.5443 0.46047 10.4449 0.52734 10.3613 0.611581C10.3612 0.611662 10.3611 0.611743 10.361 0.611824L0.611451 10.3614C0.442093 10.5307 0.346948 10.7604 0.346948 11C0.346948 11.2395 0.442093 11.4692 0.611451 11.6385C0.780809 11.8079 1.01051 11.903 1.25002 11.903C1.48953 11.903 1.71923 11.8079 1.88858 11.6385Z"
        stroke="#838383"
        strokeOpacity="0.54"
        strokeWidth="0.3"
      />
    </svg>
  ),
  SuggestionIcon: () => (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.0001 0.999878H2.00001C1.43327 0.999878 1 1.43315 1 1.99988V18C1 18.5667 1.43327 19 2.00001 19H14.0001V18.3333H2.00001C1.79997 18.3333 1.66667 18.2 1.66667 18V4.33323H20.3334V18C20.3334 18.2 20.2001 18.3333 20.0001 18.3333H16.6668V19H20.0001C20.5668 19 21.0001 18.5667 21.0001 18V1.99988C21.0001 1.43315 20.5668 0.999878 20.0001 0.999878ZM1.66667 3.66656V1.99988C1.66667 1.79985 1.79997 1.66655 2.00001 1.66655H20.0001C20.2001 1.66655 20.3334 1.79985 20.3334 1.99988V3.66656H1.66667Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M14.0001 19.1H14.1001V19V18.3333V18.2333H14.0001H2.00001C1.9227 18.2333 1.86608 18.208 1.82904 18.1709C1.79199 18.1339 1.76667 18.0773 1.76667 18V4.43323H20.2334V18C20.2334 18.0773 20.2081 18.1339 20.1711 18.1709C20.134 18.208 20.0774 18.2333 20.0001 18.2333H16.6668H16.5668V18.3333V19V19.1H16.6668H20.0001C20.6221 19.1 21.1001 18.6219 21.1001 18V1.99988C21.1001 1.37792 20.6221 0.899878 20.0001 0.899878H2.00001C1.37804 0.899878 0.9 1.37792 0.9 1.99988V18C0.9 18.6219 1.37804 19.1 2.00001 19.1H14.0001ZM1.76667 3.56656V1.99988C1.76667 1.92258 1.79199 1.86596 1.82904 1.82891C1.86608 1.79187 1.9227 1.76655 2.00001 1.76655H20.0001C20.0774 1.76655 20.134 1.79187 20.1711 1.82891C20.2081 1.86596 20.2334 1.92258 20.2334 1.99988V3.56656H1.76667Z"
        stroke="#838383"
        strokeOpacity="0.54"
        strokeWidth="0.2"
      />
      <path
        d="M2.33325 2.33337H2.99992V3.00004H2.33325V2.33337Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M2.33325 2.23337H2.23325V2.33337V3.00004V3.10004H2.33325H2.99992H3.09992V3.00004V2.33337V2.23337H2.99992H2.33325Z"
        stroke="#838383"
        strokeOpacity="0.54"
        strokeWidth="0.2"
      />
      <path
        d="M3.66663 2.33337H4.3333V3.00004H3.66663V2.33337Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M3.66663 2.23337H3.56663V2.33337V3.00004V3.10004H3.66663H4.3333H4.4333V3.00004V2.33337V2.23337H4.3333H3.66663Z"
        stroke="#838383"
        strokeOpacity="0.54"
        strokeWidth="0.2"
      />
      <path
        d="M5 2.33337H5.66667V3.00004H5V2.33337Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M5 2.23337H4.9V2.33337V3.00004V3.10004H5H5.66667H5.76667V3.00004V2.33337V2.23337H5.66667H5Z"
        stroke="#838383"
        strokeOpacity="0.54"
        strokeWidth="0.2"
      />
      <path
        d="M19.3334 5H14.6667V9.00002H19.3334V5ZM18.6668 8.33335H15.3334V5.66667H18.6668V8.33335Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M19.4334 5V4.9H19.3334H14.6667H14.5667V5V9.00002V9.10002H14.6667H19.3334H19.4334V9.00002V5ZM18.5668 8.23335H15.4334V5.76667H18.5668V8.23335Z"
        stroke="#838383"
        strokeOpacity="0.54"
        strokeWidth="0.2"
      />
      <path
        d="M2.66663 9.66663H7.33332V10.3333H2.66663V9.66663Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M2.66663 9.56663H2.56663V9.66663V10.3333V10.4333H2.66663H7.33332H7.43332V10.3333V9.66663V9.56663H7.33332H2.66663Z"
        stroke="#838383"
        strokeOpacity="0.54"
        strokeWidth="0.2"
      />
      <path
        d="M7.33332 5H2.66663V9.00002H7.33332V5ZM6.66665 8.33335H3.3333V5.66667H6.66665V8.33335Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M7.43332 5V4.9H7.33332H2.66663H2.56663V5V9.00002V9.10002H2.66663H7.33332H7.43332V9.00002V5ZM6.56665 8.23335H3.4333V5.76667H6.56665V8.23335Z"
        stroke="#838383"
        strokeOpacity="0.54"
        strokeWidth="0.2"
      />
      <path
        d="M7.33332 11.3333H2.66663V15.3333H7.33332V11.3333ZM6.66665 14.6666H3.3333V11.9999H6.66665V14.6666Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M7.43332 11.3333V11.2333H7.33332H2.66663H2.56663V11.3333V15.3333V15.4333H2.66663H7.33332H7.43332V15.3333V11.3333ZM6.56665 14.5666H3.4333V12.0999H6.56665V14.5666Z"
        stroke="#838383"
        strokeOpacity="0.54"
        strokeWidth="0.2"
      />
      <path
        d="M2.66663 16H7.33332V16.6667H2.66663V16Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M2.66663 15.9H2.56663V16V16.6667V16.7667H2.66663H7.33332H7.43332V16.6667V16V15.9H7.33332H2.66663Z"
        stroke="#838383"
        strokeOpacity="0.54"
        strokeWidth="0.2"
      />
      <path
        d="M14.6667 9.66663H19.3334V10.3333H14.6667V9.66663Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M14.6667 9.56663H14.5667V9.66663V10.3333V10.4333H14.6667H19.3334H19.4334V10.3333V9.66663V9.56663H19.3334H14.6667Z"
        stroke="#838383"
        strokeOpacity="0.54"
        strokeWidth="0.2"
      />
      <path
        d="M14.6667 16H19.3334V16.6667H14.6667V16Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M14.6667 15.9H14.5667V16V16.6667V16.7667H14.6667H19.3334H19.4334V16.6667V16V15.9H19.3334H14.6667Z"
        stroke="#838383"
        strokeOpacity="0.54"
        strokeWidth="0.2"
      />
      <path
        d="M14.6667 15.3333H19.3334V11.3333H14.6667V15.3333ZM15.3334 11.9999H18.6668V14.6666H15.3334V11.9999Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M14.5667 15.3333V15.4333H14.6667H19.3334H19.4334V15.3333V11.3333V11.2333H19.3334H14.6667H14.5667V11.3333V15.3333ZM15.4334 12.0999H18.5668V14.5666H15.4334V12.0999Z"
        stroke="#838383"
        strokeOpacity="0.54"
        strokeWidth="0.2"
      />
      <path
        d="M12.7559 10.1844L9.60901 8.08643C9.48883 8.00628 9.33425 7.99881 9.20689 8.06698C9.07952 8.13514 9 8.26788 9 8.41238V12.6083C9 12.7527 9.07952 12.8855 9.20689 12.9536C9.26481 12.9846 9.32832 13 9.39171 13C9.4677 13 9.54349 12.9779 9.60901 12.9342L12.7559 10.8362C12.8649 10.7636 12.9304 10.6413 12.9304 10.5103C12.9304 10.3793 12.8649 10.257 12.7559 10.1844ZM9.78347 11.8763V9.14434L11.8324 10.5103L9.78347 11.8763Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M9.1597 13.0418L9.15973 13.0418C9.23241 13.0807 9.31216 13.1 9.39171 13.1C9.48707 13.1 9.58224 13.0722 9.66451 13.0173L12.8114 10.9194C12.8114 10.9194 12.8114 10.9194 12.8114 10.9194C12.9482 10.8283 13.0304 10.6747 13.0304 10.5103C13.0304 10.3459 12.9482 10.1924 12.8114 10.1012L9.6645 8.00324C9.66449 8.00323 9.66449 8.00323 9.66448 8.00323C9.51361 7.90262 9.31958 7.89325 9.1597 7.97881C8.99982 8.06437 8.9 8.23101 8.9 8.41238V12.6083C8.9 12.7896 8.99982 12.9562 9.1597 13.0418ZM11.6522 10.5103L9.88347 11.6895V9.33119L11.6522 10.5103Z"
        stroke="#838383"
        strokeOpacity="0.54"
        strokeWidth="0.2"
      />
    </svg>
  ),
  ChannelsIcon: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8.08 8.86C8.13 8.53 8.24 8.24 8.38 7.99C8.52 7.74 8.72 7.53 8.97 7.37C9.21 7.22 9.51 7.15 9.88 7.14C10.11 7.15 10.32 7.19 10.51 7.27C10.71 7.36 10.89 7.48 11.03 7.63C11.17 7.78 11.28 7.96 11.37 8.16C11.46 8.36 11.5 8.58 11.51 8.8H13.3C13.28 8.33 13.19 7.9 13.02 7.51C12.85 7.12 12.62 6.78 12.32 6.5C12.02 6.22 11.66 6 11.24 5.84C10.82 5.68 10.36 5.61 9.85 5.61C9.2 5.61 8.63 5.72 8.15 5.95C7.67 6.18 7.27 6.48 6.95 6.87C6.63 7.26 6.39 7.71 6.24 8.23C6.09 8.75 6 9.29 6 9.87V10.14C6 10.72 6.08 11.26 6.23 11.78C6.38 12.3 6.62 12.75 6.94 13.13C7.26 13.51 7.66 13.82 8.14 14.04C8.62 14.26 9.19 14.38 9.84 14.38C10.31 14.38 10.75 14.3 11.16 14.15C11.57 14 11.93 13.79 12.24 13.52C12.55 13.25 12.8 12.94 12.98 12.58C13.16 12.22 13.27 11.84 13.28 11.43H11.49C11.48 11.64 11.43 11.83 11.34 12.01C11.25 12.19 11.13 12.34 10.98 12.47C10.83 12.6 10.66 12.7 10.46 12.77C10.27 12.84 10.07 12.86 9.86 12.87C9.5 12.86 9.2 12.79 8.97 12.64C8.72 12.48 8.52 12.27 8.38 12.02C8.24 11.77 8.13 11.47 8.08 11.14C8.03 10.81 8 10.47 8 10.14V9.87C8 9.52 8.03 9.19 8.08 8.86ZM2 10C2 14.41 5.59 18 10 18C14.41 18 18 14.41 18 10C18 5.59 14.41 2 10 2C5.59 2 2 5.59 2 10Z"
        fill="#838383"
        // fillOpacity='0.54'
      />
    </svg>
  ),
  ChannelsIconActive: () => (
    <svg
      width="24"
      height="24"
      // viewBox='0 0 20 20'
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8.08 8.86C8.13 8.53 8.24 8.24 8.38 7.99C8.52 7.74 8.72 7.53 8.97 7.37C9.21 7.22 9.51 7.15 9.88 7.14C10.11 7.15 10.32 7.19 10.51 7.27C10.71 7.36 10.89 7.48 11.03 7.63C11.17 7.78 11.28 7.96 11.37 8.16C11.46 8.36 11.5 8.58 11.51 8.8H13.3C13.28 8.33 13.19 7.9 13.02 7.51C12.85 7.12 12.62 6.78 12.32 6.5C12.02 6.22 11.66 6 11.24 5.84C10.82 5.68 10.36 5.61 9.85 5.61C9.2 5.61 8.63 5.72 8.15 5.95C7.67 6.18 7.27 6.48 6.95 6.87C6.63 7.26 6.39 7.71 6.24 8.23C6.09 8.75 6 9.29 6 9.87V10.14C6 10.72 6.08 11.26 6.23 11.78C6.38 12.3 6.62 12.75 6.94 13.13C7.26 13.51 7.66 13.82 8.14 14.04C8.62 14.26 9.19 14.38 9.84 14.38C10.31 14.38 10.75 14.3 11.16 14.15C11.57 14 11.93 13.79 12.24 13.52C12.55 13.25 12.8 12.94 12.98 12.58C13.16 12.22 13.27 11.84 13.28 11.43H11.49C11.48 11.64 11.43 11.83 11.34 12.01C11.25 12.19 11.13 12.34 10.98 12.47C10.83 12.6 10.66 12.7 10.46 12.77C10.27 12.84 10.07 12.86 9.86 12.87C9.5 12.86 9.2 12.79 8.97 12.64C8.72 12.48 8.52 12.27 8.38 12.02C8.24 11.77 8.13 11.47 8.08 11.14C8.03 10.81 8 10.47 8 10.14V9.87C8 9.52 8.03 9.19 8.08 8.86ZM2 10C2 14.41 5.59 18 10 18C14.41 18 18 14.41 18 10C18 5.59 14.41 2 10 2C5.59 2 2 5.59 2 10Z"
        fill="#333"
        // fillOpacity='0.54'
      />
    </svg>
  ),
  PlayListsIcon: () => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.3061 13.0228L9.59905 9.8848C9.41928 9.76492 9.18807 9.75375 8.99756 9.8557C8.80706 9.95765 8.68811 10.1562 8.68811 10.3723V16.6484C8.68811 16.8645 8.80706 17.063 8.99756 17.165C9.08421 17.2113 9.17921 17.2343 9.27401 17.2343C9.38768 17.2343 9.50104 17.2012 9.59905 17.1358L14.3061 13.9978C14.4691 13.8892 14.567 13.7062 14.567 13.5103C14.567 13.3144 14.4691 13.1315 14.3061 13.0228ZM9.85999 15.5536V11.4672L12.9248 13.5104L9.85999 15.5536Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M8.92679 17.2972L8.92683 17.2973C9.03561 17.3554 9.15495 17.3843 9.27401 17.3843C9.41671 17.3843 9.55912 17.3428 9.68225 17.2607C9.68227 17.2606 9.68229 17.2606 9.6823 17.2606L14.3893 14.1227C14.594 13.9862 14.717 13.7564 14.717 13.5103C14.717 13.2643 14.594 13.0345 14.3893 12.898L9.68227 9.76001C9.68227 9.76 9.68226 9.76 9.68226 9.75999C9.45645 9.60942 9.16606 9.5954 8.92679 9.72345C8.6875 9.85151 8.53811 10.1009 8.53811 10.3723V16.6484C8.53811 16.9198 8.68751 17.1692 8.92679 17.2972ZM12.6543 13.5104L10.01 15.2733V11.7475L12.6543 13.5104Z"
        stroke="#838383"
        strokeOpacity="0.54"
        strokeWidth="0.3"
      />
      <path
        d="M20.4141 6.02087H1.58594C1.26234 6.02087 1 6.28322 1 6.60681V20.4141C1 20.7377 1.26234 21.0001 1.58594 21.0001H20.4141C20.7377 21.0001 21 20.7377 21 20.4141V6.60681C21 6.28322 20.7377 6.02087 20.4141 6.02087ZM19.8281 19.8282H2.17188V7.19275H19.8281V19.8282Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M20.4141 5.87087H1.58594C1.1795 5.87087 0.85 6.20038 0.85 6.60681V20.4141C0.85 20.8206 1.1795 21.1501 1.58594 21.1501H20.4141C20.8205 21.1501 21.15 20.8206 21.15 20.4141V6.60681C21.15 6.20037 20.8205 5.87087 20.4141 5.87087ZM19.6781 19.6782H2.32187V7.34275H19.6781V19.6782Z"
        stroke="#838383"
        strokeOpacity="0.54"
        strokeWidth="0.3"
      />
      <path
        d="M18.5312 3.5105H3.46875C3.14516 3.5105 2.88281 3.77284 2.88281 4.09644C2.88281 4.42003 3.14516 4.68237 3.46875 4.68237H18.5312C18.8548 4.68237 19.1172 4.42003 19.1172 4.09644C19.1172 3.77284 18.8548 3.5105 18.5312 3.5105Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M18.5312 3.3605H3.46875C3.06231 3.3605 2.73281 3.69 2.73281 4.09644C2.73281 4.50287 3.06231 4.83237 3.46875 4.83237H18.5312C18.9377 4.83237 19.2672 4.50287 19.2672 4.09644C19.2672 3.69 18.9377 3.3605 18.5312 3.3605Z"
        stroke="#838383"
        strokeOpacity="0.54"
        strokeWidth="0.3"
      />
      <path
        d="M16.6484 1H5.35156C5.02797 1 4.76562 1.26234 4.76562 1.58594C4.76562 1.90953 5.02797 2.17188 5.35156 2.17188H16.6484C16.972 2.17188 17.2344 1.90953 17.2344 1.58594C17.2344 1.26234 16.972 1 16.6484 1Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M16.6484 0.85H5.35156C4.94513 0.85 4.61562 1.1795 4.61562 1.58594C4.61562 1.99237 4.94513 2.32187 5.35156 2.32187H16.6484C17.0549 2.32187 17.3844 1.99237 17.3844 1.58594C17.3844 1.1795 17.0549 0.85 16.6484 0.85Z"
        stroke="#838383"
        strokeOpacity="0.54"
        strokeWidth="0.3"
      />
    </svg>
  ),
  PlayListsIconActive: () => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.3061 13.0228L9.59905 9.8848C9.41928 9.76492 9.18807 9.75375 8.99756 9.8557C8.80706 9.95765 8.68811 10.1562 8.68811 10.3723V16.6484C8.68811 16.8645 8.80706 17.063 8.99756 17.165C9.08421 17.2113 9.17921 17.2343 9.27401 17.2343C9.38768 17.2343 9.50104 17.2012 9.59905 17.1358L14.3061 13.9978C14.4691 13.8892 14.567 13.7062 14.567 13.5103C14.567 13.3144 14.4691 13.1315 14.3061 13.0228ZM9.85999 15.5536V11.4672L12.9248 13.5104L9.85999 15.5536Z"
        fill="#434343"
        // fillOpacity='0.54'
      />
      <path
        d="M8.92679 17.2972L8.92683 17.2973C9.03561 17.3554 9.15495 17.3843 9.27401 17.3843C9.41671 17.3843 9.55912 17.3428 9.68225 17.2607C9.68227 17.2606 9.68229 17.2606 9.6823 17.2606L14.3893 14.1227C14.594 13.9862 14.717 13.7564 14.717 13.5103C14.717 13.2643 14.594 13.0345 14.3893 12.898L9.68227 9.76001C9.68227 9.76 9.68226 9.76 9.68226 9.75999C9.45645 9.60942 9.16606 9.5954 8.92679 9.72345C8.6875 9.85151 8.53811 10.1009 8.53811 10.3723V16.6484C8.53811 16.9198 8.68751 17.1692 8.92679 17.2972ZM12.6543 13.5104L10.01 15.2733V11.7475L12.6543 13.5104Z"
        stroke="#434343"
        strokeOpacity="0.54"
        strokeWidth="0.3"
      />
      <path
        d="M20.4141 6.02087H1.58594C1.26234 6.02087 1 6.28322 1 6.60681V20.4141C1 20.7377 1.26234 21.0001 1.58594 21.0001H20.4141C20.7377 21.0001 21 20.7377 21 20.4141V6.60681C21 6.28322 20.7377 6.02087 20.4141 6.02087ZM19.8281 19.8282H2.17188V7.19275H19.8281V19.8282Z"
        fill="#434343"
        // fillOpacity='0.54'
      />
      <path
        d="M20.4141 5.87087H1.58594C1.1795 5.87087 0.85 6.20038 0.85 6.60681V20.4141C0.85 20.8206 1.1795 21.1501 1.58594 21.1501H20.4141C20.8205 21.1501 21.15 20.8206 21.15 20.4141V6.60681C21.15 6.20037 20.8205 5.87087 20.4141 5.87087ZM19.6781 19.6782H2.32187V7.34275H19.6781V19.6782Z"
        stroke="#434343"
        strokeOpacity="0.54"
        strokeWidth="0.3"
      />
      <path
        d="M18.5312 3.5105H3.46875C3.14516 3.5105 2.88281 3.77284 2.88281 4.09644C2.88281 4.42003 3.14516 4.68237 3.46875 4.68237H18.5312C18.8548 4.68237 19.1172 4.42003 19.1172 4.09644C19.1172 3.77284 18.8548 3.5105 18.5312 3.5105Z"
        fill="#434343"
        // fillOpacity='0.54'
      />
      <path
        d="M18.5312 3.3605H3.46875C3.06231 3.3605 2.73281 3.69 2.73281 4.09644C2.73281 4.50287 3.06231 4.83237 3.46875 4.83237H18.5312C18.9377 4.83237 19.2672 4.50287 19.2672 4.09644C19.2672 3.69 18.9377 3.3605 18.5312 3.3605Z"
        stroke="#434343"
        strokeOpacity="0.54"
        strokeWidth="0.3"
      />
      <path
        d="M16.6484 1H5.35156C5.02797 1 4.76562 1.26234 4.76562 1.58594C4.76562 1.90953 5.02797 2.17188 5.35156 2.17188H16.6484C16.972 2.17188 17.2344 1.90953 17.2344 1.58594C17.2344 1.26234 16.972 1 16.6484 1Z"
        fill="#434343"
        // fillOpacity='0.54'
      />
      <path
        d="M16.6484 0.85H5.35156C4.94513 0.85 4.61562 1.1795 4.61562 1.58594C4.61562 1.99237 4.94513 2.32187 5.35156 2.32187H16.6484C17.0549 2.32187 17.3844 1.99237 17.3844 1.58594C17.3844 1.1795 17.0549 0.85 16.6484 0.85Z"
        stroke="#434343"
        strokeOpacity="0.54"
        strokeWidth="0.3"
      />
    </svg>
  ),
  CategoryIcon: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon/action/vertical_split_24px">
        <g id="icon/action/vertical_split_24px_2">
          <mask
            id="path-1-outside-1_1263_28331"
            maskUnits="userSpaceOnUse"
            x="2"
            y="4"
            width="20"
            height="16"
            fill="black"
          >
            <rect fill="white" x="2" y="4" width="20" height="16" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3 6C3 6.55 3.45 7 4 7H10C10.55 7 11 6.55 11 6C11 5.45 10.55 5 10 5H4C3.45 5 3 5.45 3 6ZM10 11H4C3.45 11 3 10.55 3 10C3 9.45 3.45 9 4 9H10C10.55 9 11 9.45 11 10C11 10.55 10.55 11 10 11ZM4 15H10C10.55 15 11 14.55 11 14C11 13.45 10.55 13 10 13H4C3.45 13 3 13.45 3 14C3 14.55 3.45 15 4 15ZM4 19H10C10.55 19 11 18.55 11 18C11 17.45 10.55 17 10 17H4C3.45 17 3 17.45 3 18C3 18.55 3.45 19 4 19ZM20 5H14C13.45 5 13 5.45 13 6V18C13 18.55 13.45 19 14 19H20C20.55 19 21 18.55 21 18V6C21 5.45 20.55 5 20 5Z"
            />
          </mask>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 6C3 6.55 3.45 7 4 7H10C10.55 7 11 6.55 11 6C11 5.45 10.55 5 10 5H4C3.45 5 3 5.45 3 6ZM10 11H4C3.45 11 3 10.55 3 10C3 9.45 3.45 9 4 9H10C10.55 9 11 9.45 11 10C11 10.55 10.55 11 10 11ZM4 15H10C10.55 15 11 14.55 11 14C11 13.45 10.55 13 10 13H4C3.45 13 3 13.45 3 14C3 14.55 3.45 15 4 15ZM4 19H10C10.55 19 11 18.55 11 18C11 17.45 10.55 17 10 17H4C3.45 17 3 17.45 3 18C3 18.55 3.45 19 4 19ZM20 5H14C13.45 5 13 5.45 13 6V18C13 18.55 13.45 19 14 19H20C20.55 19 21 18.55 21 18V6C21 5.45 20.55 5 20 5Z"
            fill="#838383"
            fill-opacity="0.54"
          />
          <path
            d="M4 6.7C3.61569 6.7 3.3 6.38431 3.3 6H2.7C2.7 6.71569 3.28431 7.3 4 7.3V6.7ZM10 6.7H4V7.3H10V6.7ZM10.7 6C10.7 6.38431 10.3843 6.7 10 6.7V7.3C10.7157 7.3 11.3 6.71569 11.3 6H10.7ZM10 5.3C10.3843 5.3 10.7 5.61569 10.7 6H11.3C11.3 5.28431 10.7157 4.7 10 4.7V5.3ZM4 5.3H10V4.7H4V5.3ZM3.3 6C3.3 5.61569 3.61569 5.3 4 5.3V4.7C3.28431 4.7 2.7 5.28431 2.7 6H3.3ZM4 11.3H10V10.7H4V11.3ZM2.7 10C2.7 10.7157 3.28431 11.3 4 11.3V10.7C3.61569 10.7 3.3 10.3843 3.3 10H2.7ZM4 8.7C3.28431 8.7 2.7 9.28431 2.7 10H3.3C3.3 9.61569 3.61569 9.3 4 9.3V8.7ZM10 8.7H4V9.3H10V8.7ZM11.3 10C11.3 9.28431 10.7157 8.7 10 8.7V9.3C10.3843 9.3 10.7 9.61569 10.7 10H11.3ZM10 11.3C10.7157 11.3 11.3 10.7157 11.3 10H10.7C10.7 10.3843 10.3843 10.7 10 10.7V11.3ZM10 14.7H4V15.3H10V14.7ZM10.7 14C10.7 14.3843 10.3843 14.7 10 14.7V15.3C10.7157 15.3 11.3 14.7157 11.3 14H10.7ZM10 13.3C10.3843 13.3 10.7 13.6157 10.7 14H11.3C11.3 13.2843 10.7157 12.7 10 12.7V13.3ZM4 13.3H10V12.7H4V13.3ZM3.3 14C3.3 13.6157 3.61569 13.3 4 13.3V12.7C3.28431 12.7 2.7 13.2843 2.7 14H3.3ZM4 14.7C3.61569 14.7 3.3 14.3843 3.3 14H2.7C2.7 14.7157 3.28431 15.3 4 15.3V14.7ZM10 18.7H4V19.3H10V18.7ZM10.7 18C10.7 18.3843 10.3843 18.7 10 18.7V19.3C10.7157 19.3 11.3 18.7157 11.3 18H10.7ZM10 17.3C10.3843 17.3 10.7 17.6157 10.7 18H11.3C11.3 17.2843 10.7157 16.7 10 16.7V17.3ZM4 17.3H10V16.7H4V17.3ZM3.3 18C3.3 17.6157 3.61569 17.3 4 17.3V16.7C3.28431 16.7 2.7 17.2843 2.7 18H3.3ZM4 18.7C3.61569 18.7 3.3 18.3843 3.3 18H2.7C2.7 18.7157 3.28431 19.3 4 19.3V18.7ZM14 5.3H20V4.7H14V5.3ZM13.3 6C13.3 5.61569 13.6157 5.3 14 5.3V4.7C13.2843 4.7 12.7 5.28431 12.7 6H13.3ZM13.3 18V6H12.7V18H13.3ZM14 18.7C13.6157 18.7 13.3 18.3843 13.3 18H12.7C12.7 18.7157 13.2843 19.3 14 19.3V18.7ZM20 18.7H14V19.3H20V18.7ZM20.7 18C20.7 18.3843 20.3843 18.7 20 18.7V19.3C20.7157 19.3 21.3 18.7157 21.3 18H20.7ZM20.7 6V18H21.3V6H20.7ZM20 5.3C20.3843 5.3 20.7 5.61569 20.7 6H21.3C21.3 5.28431 20.7157 4.7 20 4.7V5.3Z"
            fill="#838383"
            fill-opacity="0.54"
            mask="url(#path-1-outside-1_1263_28331)"
          />
        </g>
      </g>
    </svg>
  ),
  CameraIcon: () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.1179 13.1295C19.5447 13.1295 19.8906 12.7835 19.8906 12.3568V8.91821C19.8906 8.63946 19.7405 8.3823 19.4977 8.2453C19.255 8.1083 18.9572 8.11259 18.7186 8.25666L15.602 10.1378C15.5962 9.04764 15.0225 8.08991 14.1629 7.54403C15.0449 6.76476 15.6021 5.62595 15.6021 4.35925C15.6021 2.01587 13.6956 0.109375 11.3522 0.109375C9.01554 0.109375 7.11344 2.00501 7.10263 4.33924C6.76349 2.74144 5.34186 1.53888 3.6445 1.53888C1.69524 1.53888 0.109375 3.12474 0.109375 5.07401C0.109375 6.12515 0.57068 7.0704 1.30127 7.71851C0.57663 8.28463 0.109375 9.16579 0.109375 10.1545V16.7998C0.109375 18.5041 1.49592 19.8906 3.2002 19.8906H12.5113C14.2156 19.8906 15.6021 18.5041 15.6021 16.7998V16.7674L18.723 18.623C18.9618 18.765 19.2585 18.7678 19.4999 18.6305C19.7415 18.4931 19.8906 18.2367 19.8906 17.9589V16.2203C19.8906 15.7935 19.5447 15.4476 19.1179 15.4476C18.6912 15.4476 18.3452 15.7935 18.3452 16.2203V16.6004L15.2243 14.7448C14.9855 14.6027 14.6889 14.6 14.4474 14.7373C14.2059 14.8746 14.0567 15.1311 14.0567 15.4089V16.7998C14.0567 17.6519 13.3634 18.3452 12.5113 18.3452H3.2002C2.34806 18.3452 1.65479 17.6519 1.65479 16.7998V10.1545C1.65479 9.3024 2.34806 8.60913 3.2002 8.60913H12.5113C13.3634 8.60913 14.0567 9.3024 14.0567 10.1545V11.5068C14.0567 11.7855 14.2068 12.0426 14.4496 12.1797C14.6923 12.3167 14.9901 12.3124 15.2287 12.1683L18.3452 10.2872V12.3568C18.3452 12.7835 18.6912 13.1295 19.1179 13.1295ZM3.6445 7.06372C2.54738 7.06372 1.65479 6.17113 1.65479 5.07401C1.65479 3.97688 2.54738 3.08429 3.6445 3.08429C4.74163 3.08429 5.63422 3.97688 5.63422 5.07401C5.63422 6.17113 4.74163 7.06372 3.6445 7.06372ZM6.56494 7.06372C6.93731 6.51889 7.16143 5.86514 7.17851 5.1609C7.31524 5.87414 7.63054 6.52468 8.07631 7.06372H6.56494ZM11.3522 7.06372C9.86099 7.06372 8.64777 5.8505 8.64777 4.35925C8.64777 2.86801 9.86099 1.65479 11.3522 1.65479C12.8435 1.65479 14.0567 2.86801 14.0567 4.35925C14.0567 5.8505 12.8435 7.06372 11.3522 7.06372Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M6.34562 16.5222C6.37967 16.5222 6.41338 16.5257 6.44708 16.5322C6.48044 16.5388 6.5131 16.5484 6.54438 16.5615C6.57565 16.5746 6.60588 16.5902 6.63438 16.6091C6.66287 16.6278 6.68893 16.6491 6.71325 16.6729C6.73758 16.6967 6.75877 16.723 6.77788 16.7509C6.797 16.7788 6.81298 16.8085 6.82584 16.8399C6.83869 16.8713 6.84877 16.9034 6.85537 16.9365C6.86198 16.9696 6.86545 17.003 6.86545 17.0368C6.86545 17.0706 6.86198 17.1041 6.85537 17.1372C6.84877 17.1703 6.83869 17.2024 6.82584 17.2338C6.81298 17.2652 6.79665 17.2945 6.77788 17.3228C6.75877 17.3507 6.73723 17.3769 6.71325 17.4007C6.68928 17.4245 6.66287 17.4459 6.63438 17.4645C6.60588 17.4832 6.576 17.499 6.54438 17.5121C6.51276 17.5249 6.48044 17.5349 6.44708 17.5414C6.41372 17.548 6.37967 17.5515 6.34562 17.5515C6.31157 17.5515 6.27786 17.548 6.24415 17.5414C6.2108 17.5349 6.17813 17.5252 6.14651 17.5121C6.11489 17.4994 6.08501 17.4835 6.05651 17.4645C6.02802 17.4459 6.00196 17.4245 5.97764 17.4007C5.95366 17.3769 5.93212 17.3507 5.913 17.3228C5.89389 17.2948 5.87791 17.2652 5.86505 17.2338C5.85185 17.2027 5.84212 17.1703 5.83552 17.1372C5.82891 17.1041 5.82544 17.0706 5.82544 17.0368C5.82544 17.003 5.82891 16.9696 5.83552 16.9365C5.84212 16.9034 5.8522 16.8713 5.86505 16.8399C5.87826 16.8088 5.89424 16.7792 5.913 16.7509C5.93177 16.7226 5.95366 16.6967 5.97764 16.6729C6.00161 16.6491 6.02802 16.6278 6.05651 16.6091C6.08501 16.5905 6.11489 16.5746 6.14651 16.5615C6.17813 16.5488 6.21045 16.5388 6.24415 16.5322C6.27786 16.5253 6.31157 16.5222 6.34562 16.5222Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M7.99101 16.5222C8.02506 16.5222 8.05877 16.5257 8.09247 16.5322C8.12583 16.5388 8.1585 16.5484 8.18977 16.5615C8.22104 16.5746 8.25127 16.5902 8.27977 16.6091C8.30826 16.6278 8.33432 16.6491 8.35865 16.6729C8.38297 16.6967 8.40417 16.723 8.42328 16.7509C8.44239 16.7788 8.45837 16.8085 8.47123 16.8399C8.48409 16.8713 8.49417 16.9034 8.50077 16.9365C8.50737 16.9696 8.51084 17.003 8.51084 17.0368C8.51084 17.0706 8.50737 17.1041 8.50077 17.1372C8.49417 17.1703 8.48409 17.2024 8.47123 17.2338C8.45837 17.2652 8.44204 17.2945 8.42328 17.3228C8.40417 17.3507 8.38262 17.3769 8.35865 17.4007C8.33467 17.4245 8.30826 17.4459 8.27977 17.4645C8.25127 17.4832 8.22139 17.499 8.18977 17.5121C8.15815 17.5249 8.12583 17.5349 8.09247 17.5414C8.05912 17.548 8.02506 17.5515 7.99101 17.5515C7.95696 17.5515 7.92325 17.548 7.88954 17.5414C7.85618 17.5349 7.82352 17.5252 7.7919 17.5121C7.76028 17.4994 7.7304 17.4835 7.7019 17.4645C7.67341 17.4459 7.64735 17.4245 7.62302 17.4007C7.59905 17.3769 7.5775 17.3507 7.55839 17.3228C7.53928 17.2948 7.5233 17.2652 7.51044 17.2338C7.49723 17.2027 7.4875 17.1703 7.4809 17.1372C7.4743 17.1041 7.47083 17.0706 7.47083 17.0368C7.47083 17.003 7.4743 16.9696 7.4809 16.9365C7.4875 16.9034 7.49758 16.8713 7.51044 16.8399C7.52364 16.8088 7.53963 16.7792 7.55839 16.7509C7.57716 16.7226 7.59905 16.6967 7.62302 16.6729C7.647 16.6491 7.67341 16.6278 7.7019 16.6091C7.7304 16.5905 7.76028 16.5746 7.7919 16.5615C7.82352 16.5488 7.85584 16.5388 7.88954 16.5322C7.92325 16.5253 7.95696 16.5222 7.99101 16.5222Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M9.61466 16.5222C9.64871 16.5222 9.68242 16.5257 9.71613 16.5322C9.74948 16.5388 9.78215 16.5484 9.81342 16.5615C9.84469 16.5746 9.87492 16.5902 9.90342 16.6091C9.93191 16.6278 9.95797 16.6491 9.9823 16.6729C10.0066 16.6967 10.0278 16.723 10.0469 16.7509C10.066 16.7788 10.082 16.8085 10.0949 16.8399C10.1077 16.8713 10.1178 16.9034 10.1244 16.9365C10.131 16.9696 10.1345 17.003 10.1345 17.0368C10.1345 17.0706 10.131 17.1041 10.1244 17.1372C10.1178 17.1703 10.1077 17.2024 10.0949 17.2338C10.082 17.2652 10.0657 17.2945 10.0469 17.3228C10.0278 17.3507 10.0063 17.3769 9.9823 17.4007C9.95832 17.4245 9.93191 17.4459 9.90342 17.4645C9.87492 17.4832 9.84504 17.499 9.81342 17.5121C9.7818 17.5249 9.74948 17.5349 9.71613 17.5414C9.68277 17.548 9.64871 17.5515 9.61466 17.5515C9.58061 17.5515 9.5469 17.548 9.5132 17.5414C9.47984 17.5349 9.44718 17.5252 9.41555 17.5121C9.38393 17.4994 9.35405 17.4835 9.32556 17.4645C9.29706 17.4459 9.271 17.4245 9.24668 17.4007C9.2227 17.3769 9.20116 17.3507 9.18205 17.3228C9.16294 17.2948 9.14695 17.2652 9.1341 17.2338C9.12089 17.2027 9.11116 17.1703 9.10456 17.1372C9.09796 17.1041 9.09448 17.0706 9.09448 17.0368C9.09448 17.003 9.09796 16.9696 9.10456 16.9365C9.11116 16.9034 9.12124 16.8713 9.1341 16.8399C9.1473 16.8088 9.16328 16.7792 9.18205 16.7509C9.20081 16.7226 9.2227 16.6967 9.24668 16.6729C9.27066 16.6491 9.29706 16.6278 9.32556 16.6091C9.35405 16.5905 9.38393 16.5746 9.41555 16.5615C9.44718 16.5488 9.47949 16.5388 9.5132 16.5322C9.54655 16.5253 9.58026 16.5222 9.61466 16.5222Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M6.36599 10.4286C6.36286 10.4366 6.05985 11.2699 6.25896 12.0318C6.2878 12.1418 6.22109 12.2543 6.11024 12.2829C5.99939 12.3115 5.88611 12.2456 5.85727 12.1356V12.1349C5.75789 11.7541 5.76276 11.3675 5.80202 11.0467C5.20853 11.8825 5.16092 12.9852 5.68006 13.8685C6.26209 14.8636 7.42685 15.3689 8.5579 15.1171L8.04467 14.2348C7.46854 14.3914 6.85871 14.3755 6.29162 14.19C6.18252 14.1548 6.1231 14.0385 6.15854 13.9302V13.9299C6.19398 13.8216 6.31108 13.7626 6.41985 13.7978H6.42019C6.95809 13.974 7.53908 13.973 8.07629 13.7943C8.16976 13.7633 8.27262 13.8019 8.32196 13.8868L9.05063 15.1412C9.0819 15.1947 9.08711 15.2595 9.06488 15.3175C9.04264 15.3754 8.99573 15.4203 8.93631 15.4399C7.5648 15.8939 6.04387 15.3199 5.31972 14.0751C4.95313 13.4453 4.82664 12.7054 4.96286 11.9908C5.09733 11.2854 5.47887 10.6497 6.04005 10.1968C6.11267 10.1382 6.21587 10.1354 6.29162 10.1896C6.3156 10.2065 6.33575 10.2286 6.35035 10.2537C6.38197 10.3072 6.38718 10.371 6.36599 10.4286ZM11.0191 13.0721C10.8846 13.7774 10.5031 14.4131 9.94192 14.866C9.86929 14.9246 9.76609 14.9274 9.69034 14.8732C9.61424 14.8191 9.58401 14.7211 9.61668 14.6342C9.6198 14.6259 9.92281 13.793 9.7237 13.031C9.69486 12.921 9.76158 12.8086 9.87242 12.7799C9.98327 12.7513 10.0965 12.8175 10.1254 12.9276C10.2248 13.3083 10.2199 13.695 10.1806 14.0158C10.7741 13.1797 10.8217 12.077 10.3026 11.1936C9.72057 10.1986 8.55581 9.69325 7.42476 9.94504L7.93799 10.8273C8.51412 10.6708 9.12395 10.6866 9.69104 10.8722C9.80015 10.9074 9.85957 11.0239 9.82412 11.1323C9.78868 11.2406 9.67123 11.2995 9.56247 11.264C9.02457 11.0878 8.44358 11.0891 7.90637 11.2675C7.8129 11.2985 7.71004 11.2599 7.6607 11.175L6.93134 9.92124C6.90007 9.86778 6.89485 9.80294 6.91709 9.74499C6.93933 9.68704 6.98624 9.64221 7.04566 9.62254C8.41717 9.16863 9.93844 9.74258 10.6622 10.9874C11.0288 11.6176 11.1557 12.3571 11.0191 13.0721Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M6.09941 12.2363C6.1835 12.2139 6.23424 12.1276 6.21234 12.0435C6.01115 11.2726 6.30825 10.4469 6.32076 10.412V10.4117C6.33744 10.3672 6.33327 10.3185 6.30929 10.2775C6.29782 10.2578 6.28254 10.2413 6.26412 10.2282C6.20574 10.1864 6.12617 10.1889 6.07057 10.2337C5.51877 10.679 5.14245 11.3057 5.01041 11.9993C4.87628 12.7026 5.00102 13.4311 5.36136 14.0509V14.0512C6.07405 15.2761 7.571 15.841 8.92131 15.3944C8.96683 15.3792 9.00297 15.345 9.01999 15.3002C9.03702 15.2554 9.0332 15.206 9.00922 15.1646L8.27986 13.9109C8.24198 13.846 8.16276 13.816 8.09118 13.8398C7.54806 14.0202 6.9497 14.0216 6.40554 13.8436L6.40485 13.8433C6.36419 13.8302 6.32111 13.8336 6.28323 13.8526C6.2457 13.8715 6.21756 13.904 6.20435 13.9436L6.204 13.9447C6.1908 13.9847 6.19428 14.0278 6.21339 14.0654C6.2325 14.1033 6.26551 14.1309 6.30616 14.144C6.8663 14.3275 7.46293 14.3427 8.03176 14.1882L8.06755 14.1785L8.63151 15.1498L8.56792 15.164C8.00292 15.2899 7.42401 15.2347 6.89341 15.0043C6.3628 14.7742 5.9288 14.3896 5.63796 13.8926C5.63587 13.8891 5.63414 13.8857 5.63205 13.8822C5.11152 12.9872 5.16226 11.8645 5.76236 11.0191L5.87251 10.8642L5.84957 11.0525C5.80162 11.4426 5.82004 11.8027 5.90343 12.1232L5.90413 12.1252C5.91525 12.1652 5.94096 12.199 5.97745 12.2201C6.01428 12.2415 6.05702 12.2473 6.09837 12.2366L6.09941 12.2363ZM6.39234 10.2299C6.43056 10.2954 6.43717 10.3737 6.41076 10.4448C6.40381 10.4638 6.11262 11.2822 6.30512 12.0193C6.34057 12.1545 6.25856 12.2935 6.122 12.3287L6.11713 12.3298C6.0525 12.3453 5.98579 12.3353 5.9281 12.3022C5.86938 12.268 5.82733 12.2132 5.81031 12.1476L5.80961 12.1452C5.73734 11.8679 5.71232 11.5627 5.7349 11.2357C5.25781 12.0286 5.2453 13.0275 5.7151 13.835C5.71718 13.8384 5.71892 13.8415 5.72101 13.845C6.00142 14.3244 6.42014 14.6952 6.93163 14.9173C7.42332 15.1305 7.95809 15.1881 8.48244 15.085L8.02099 14.2903C7.44486 14.4396 6.84233 14.4207 6.27628 14.2351C6.21165 14.2141 6.15918 14.1696 6.12791 14.1092C6.09698 14.0492 6.09177 13.9809 6.11227 13.9171L6.11262 13.9157C6.15605 13.7832 6.29991 13.7101 6.43334 13.7525L6.43682 13.7536C6.96082 13.925 7.53764 13.9236 8.06095 13.7498C8.17561 13.7118 8.30279 13.7598 8.36325 13.8636L9.09227 15.117C9.13084 15.1833 9.1371 15.2623 9.10964 15.334C9.08219 15.4054 9.02451 15.4606 8.95154 15.4847C7.55814 15.9459 6.01324 15.3626 5.27797 14.0985V14.0982C4.90616 13.4587 4.77725 12.7071 4.91589 11.9814C5.0521 11.266 5.44094 10.619 6.01011 10.1595C6.09941 10.0878 6.22694 10.084 6.32006 10.1506C6.3496 10.1716 6.37392 10.1982 6.39234 10.2299ZM9.67291 14.7845C9.68403 14.8035 9.69932 14.8204 9.71808 14.8339C9.77646 14.8753 9.85603 14.8732 9.91163 14.8283C10.4631 14.3831 10.8398 13.7563 10.9718 13.0627C11.1059 12.3594 10.9815 11.631 10.6208 11.0111V11.0108C9.90816 9.78565 8.41121 9.22067 7.06089 9.66734C7.01537 9.68251 6.97924 9.71666 6.96221 9.7615C6.94518 9.80634 6.94901 9.85532 6.97333 9.89671L7.70234 11.1508C7.74022 11.2157 7.81945 11.2457 7.89103 11.2219C8.43414 11.0415 9.0332 11.0401 9.57735 11.2184C9.66075 11.2453 9.7511 11.1998 9.77855 11.117C9.80565 11.0339 9.75978 10.9442 9.67639 10.9173C9.11625 10.7338 8.51962 10.7186 7.95079 10.8732L7.915 10.8828L7.35069 9.91257L7.41428 9.89843C7.97929 9.77254 8.55819 9.82772 9.0888 10.0581C9.6194 10.2882 10.0534 10.6728 10.3442 11.1698C10.3463 11.1733 10.3484 11.1767 10.3502 11.1801C10.871 12.0745 10.8203 13.1972 10.2198 14.0426L10.1097 14.1975L10.1326 14.0092C10.1802 13.6208 10.1625 13.2621 10.0798 12.943L10.0788 12.9385C10.068 12.8975 10.0419 12.8634 10.0051 12.8416C9.96862 12.8202 9.92623 12.8144 9.88522 12.8247L9.88001 12.8261C9.79731 12.8499 9.74797 12.9351 9.76986 13.0182C9.97175 13.7912 9.66457 14.6414 9.66145 14.65C9.64442 14.6952 9.64963 14.7445 9.67291 14.7845ZM10.7042 10.9635C11.076 11.603 11.2046 12.3549 11.0663 13.0803C10.9301 13.7957 10.5413 14.4427 9.97209 14.9022C9.88279 14.9739 9.75527 14.9777 9.66214 14.9111C9.56902 14.8446 9.53149 14.7238 9.57145 14.6169C9.57423 14.609 9.87132 13.786 9.67708 13.0424C9.64164 12.9072 9.7233 12.7688 9.85916 12.7333H9.85951L9.8602 12.733L9.86507 12.7319C9.9297 12.7164 9.99676 12.7264 10.0541 12.7599C10.1111 12.793 10.1521 12.8458 10.1702 12.9082V12.9085L10.1719 12.9147C10.2445 13.1924 10.2695 13.498 10.247 13.826C10.724 13.0331 10.7366 12.0342 10.2668 11.2267C10.2647 11.2233 10.2629 11.2202 10.2609 11.2167C9.98043 10.7373 9.56172 10.3665 9.05023 10.1444C8.55854 9.9312 8.02377 9.8736 7.49942 9.97707L7.96122 10.7714C8.53734 10.6221 9.13988 10.641 9.70592 10.8266C9.8397 10.8701 9.91337 11.0136 9.86959 11.1467C9.8258 11.2798 9.68125 11.3526 9.54712 11.3091C9.02243 11.1374 8.44526 11.1384 7.92126 11.3126C7.80659 11.3505 7.67941 11.3026 7.61895 11.1988L6.88959 9.945C6.85102 9.87877 6.84476 9.79979 6.87221 9.72804C6.89966 9.65665 6.95734 9.60146 7.03032 9.57731C8.42372 9.11616 9.96862 9.69907 10.7042 10.9635Z"
        fill="#B0B0B0"
      />
    </svg>
  ),
  SettingsIcon: ({
    width = '20px',
    height = '20px',
    fill = '#BCBCBC',
    className,
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      version="1.1"
      viewBox="0 0 559.6 564.28"
      fill={fill}
      className={className}
    >
      <g id="Layer_x0020_1">
        <metadata id="CorelCorpID_0Corel-Layer" />
        <path
          className="fil0"
          d="M221.2 0c45.11,0 72.15,0 117.27,0 17.13,0.3 26.09,14.18 30.94,24.82 10.99,24.12 -0.35,59.09 28.2,65.41 32.63,7.24 52.53,-27 83.46,-11.28 25.35,12.89 59.77,82.58 74.44,109.41 23.05,42.16 -59.08,60.62 -50.76,101.5 4.83,23.71 18.81,29.62 37.6,45.12 14.81,12.22 13.36,39.81 4.71,54.3 -13.52,22.67 -29.45,51.69 -51.07,85.94 -12.38,19.62 -32.68,19.15 -52.5,7.8 -17.25,-9.88 -33.39,-18.86 -52.66,-7.05 -18.02,11.04 -16.14,26.42 -18.33,46.51 -2.99,27.38 -14.22,40.71 -40.71,40.99 -39.19,0.43 -70.44,0.8 -105.93,0.82 -19.71,0.01 -37.89,-14.57 -38.67,-37.1 -1.53,-44.28 -13.44,-52 -24.31,-56.75 -31.44,-13.71 -68.99,49.81 -105.65,0.96 -18.31,-31.77 -38.09,-66.13 -54.38,-95.81 -5.07,-9.57 -4.76,-28.41 12.63,-44.21 15.63,-14.18 37.72,-28.19 38.69,-49.76 1.24,-27.29 -21.24,-37.46 -38.94,-50.38 -15.98,-11.66 -12.42,-43.44 -6.1,-54.28 17.08,-29.31 30.32,-51.55 48.99,-82.22 15.42,-25.33 33.92,-21.16 52.18,-14.26 17.24,6.51 37.08,18.98 54.97,8.63 21.33,-12.33 14.94,-38.9 22.56,-62.03 4.06,-12.33 19.02,-26.65 33.38,-27.07zm16.96 56.63c-6.21,43.72 -19.45,69.39 -39.4,81.91 -23.45,14.73 -56.2,11.33 -97.75,-2.17 -6.12,9.18 -33.11,56.4 -42.03,72.1 36.88,26.34 52.6,53.78 50.3,80.84 -2.13,25.09 -19.73,49.87 -50.3,73.18 14.01,24.03 28.02,48.06 42.03,72.1 38.64,-12.1 69.53,-19.02 90.72,-5.61 23.8,15.06 38.02,34 44.21,83.17 28.75,0 57.51,0 86.27,0 3.55,-30.24 13.02,-62.68 39.12,-79.5 28.95,-18.66 70.61,-12.59 95.81,0.84 7.56,-12.49 32.45,-55.52 42.03,-72.1 -34.09,-23.05 -46.06,-49.86 -45.67,-74.96 0.53,-34.12 23.92,-65.07 45.67,-79.05 -14.01,-24.03 -28.02,-48.07 -42.03,-72.1 -41.03,17.24 -73.43,18.13 -96.42,2.69 -20.49,-13.77 -33.51,-40.52 -38.51,-80.25 -28.02,-0.36 -56.04,-0.73 -84.05,-1.09z"
        />
        <path
          className="fil0"
          d="M275.79 169.18c80,1.25 139.92,76.16 106.02,159.03 -40.51,99.01 -189.85,81.23 -213.01,-17.59 -15.71,-67.03 37.7,-142.52 107,-141.44zm-53.8 99.08c-10.02,41.3 29.34,81.21 70.91,70.91 44.34,-11 55.38,-65 30.96,-94.97 -28.39,-34.83 -89.96,-24.98 -101.87,24.06z"
        />
      </g>
    </svg>
    // <svg
    //   width='24'
    //   height='24'
    //   viewBox='0 0 24 24'
    //   fill='none'
    //   xmlns='http://www.w3.org/2000/svg'
    // >
    //   <path
    //     d='M22.9459 13.9076L21.9475 13.0857C21.2636 12.5227 21.2648 11.4762 21.9475 10.9143L22.9459 10.0924C23.6564 9.50747 23.8382 8.50444 23.378 7.70733L21.4066 4.29267C20.9463 3.49561 19.9866 3.15155 19.125 3.47433L17.914 3.92803C17.0845 4.23872 16.1788 3.7147 16.0335 2.84236L15.8209 1.5667C15.6696 0.658922 14.8918 0 13.9714 0H10.0285C9.10816 0 8.33031 0.658922 8.17905 1.56675L7.96642 2.84236C7.82078 3.71625 6.91394 4.2382 6.08599 3.92808L4.87497 3.47433C4.01327 3.15155 3.05364 3.49566 2.59338 4.29267L0.621955 7.70728C0.161783 8.5043 0.343471 9.50737 1.05405 10.0924L2.05244 10.9143C2.73644 11.4773 2.73508 12.5237 2.05244 13.0856L1.054 13.9075C0.343471 14.4925 0.161736 15.4956 0.621908 16.2926L2.59338 19.7073C3.0536 20.5043 4.01303 20.8484 4.87497 20.5256L6.08594 20.0719C6.91558 19.7611 7.82102 20.2855 7.96638 21.1576L8.179 22.4332C8.33031 23.3411 9.10816 24 10.0285 24H13.9714C14.8917 24 15.6696 23.3411 15.8208 22.4333L16.0334 21.1577C16.179 20.284 17.0858 19.7617 17.9139 20.072L19.125 20.5257C19.9869 20.8485 20.9463 20.5044 21.4066 19.7073L23.3781 16.2926C23.8382 15.4956 23.6564 14.4925 22.9459 13.9076ZM19.7828 18.7698L18.5718 18.3161C16.6359 17.5909 14.5232 18.8144 14.184 20.8494L13.9714 22.125H10.0285L9.81592 20.8494C9.47613 18.8105 7.36033 17.5923 5.42819 18.3161L4.21717 18.7698L2.24575 15.3552L3.24414 14.5333C4.84019 13.2194 4.83686 10.7779 3.24414 9.46673L2.24575 8.64483L4.21722 5.23017L5.42819 5.68388C7.36413 6.40903 9.47678 5.18559 9.81592 3.15061L10.0285 1.875H13.9714L14.184 3.15061C14.5238 5.18977 16.6397 6.40753 18.5717 5.68388L19.7827 5.23017L21.7546 8.64436C21.7546 8.64436 21.7545 8.6445 21.7541 8.64478L20.7558 9.46669C19.1598 10.7805 19.1629 13.222 20.7557 14.5332L21.7541 15.3551L19.7828 18.7698ZM12 7.37498C9.44974 7.37498 7.37496 9.44977 7.37496 12C7.37496 14.5502 9.44974 16.625 12 16.625C14.5502 16.625 16.625 14.5502 16.625 12C16.625 9.44977 14.5502 7.37498 12 7.37498ZM12 14.75C10.4836 14.75 9.24996 13.5164 9.24996 12C9.24996 10.4836 10.4836 9.24998 12 9.24998C13.5163 9.24998 14.75 10.4836 14.75 12C14.75 13.5164 13.5163 14.75 12 14.75Z'
    //     fill='#838383'
    //     fillOpacity='0.54'
    //   />
    // </svg>
  ),
  QuestionIcon: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.47301 2 2 6.4725 2 12C2 17.5269 6.4725 22 12 22C17.527 22 22 17.5275 22 12C22 6.47301 17.5275 2 12 2ZM12 20.6046C7.25539 20.6046 3.39535 16.7446 3.39535 12C3.39535 7.25535 7.25539 3.39535 12 3.39535C16.7446 3.39535 20.6046 7.25535 20.6046 12C20.6046 16.7446 16.7446 20.6046 12 20.6046Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M12 1.75C6.33495 1.75 1.75 6.33442 1.75 12C1.75 17.665 6.33442 22.25 12 22.25C17.6651 22.25 22.25 17.6656 22.25 12C22.25 6.33495 17.6656 1.75 12 1.75ZM12 20.3546C7.39346 20.3546 3.64535 16.6066 3.64535 12C3.64535 7.39342 7.39346 3.64535 12 3.64535C16.6066 3.64535 20.3546 7.39342 20.3546 12C20.3546 16.6066 16.6066 20.3546 12 20.3546Z"
        stroke="#838383"
        strokeOpacity="0.54"
        strokeWidth="0.5"
      />
      <path
        d="M11.645 15.1838C10.9815 15.1838 10.4445 15.7367 10.4445 16.4001C10.4445 17.0477 10.9657 17.6164 11.645 17.6164C12.3242 17.6164 12.8612 17.0477 12.8612 16.4001C12.8612 15.7367 12.3083 15.1838 11.645 15.1838Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M11.8502 5.9751C9.71781 5.9751 8.73849 7.2388 8.73849 8.09174C8.73849 8.70777 9.25974 8.99211 9.68621 8.99211C10.5392 8.99211 10.1917 7.7758 11.8028 7.7758C12.5926 7.7758 13.2245 8.12333 13.2245 8.84994C13.2245 9.70288 12.3399 10.1925 11.8186 10.6348C11.3605 11.0296 10.7604 11.6773 10.7604 13.0357C10.7604 13.8571 10.9815 14.094 11.6291 14.094C12.403 14.094 12.561 13.7466 12.561 13.4464C12.561 12.625 12.5768 12.1512 13.4456 11.4719C13.872 11.1403 15.2146 10.0661 15.2146 8.58135C15.2146 7.09658 13.872 5.9751 11.8502 5.9751Z"
        fill="#838383"
        fillOpacity="0.54"
      />
    </svg>
  ),
  ReportIcon: () => (
    <svg
      width="24"
      height="23"
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.0749 3.69172L20.8248 1.44172C20.6054 1.22225 20.2495 1.22197 20.0299 1.44144C20.0299 1.44158 20.0297 1.44172 20.0294 1.44172L13.2796 8.19186C13.174 8.29726 13.1149 8.44022 13.1149 8.58938V10.8395C13.1149 11.1501 13.3667 11.4019 13.6772 11.4019H15.9274C16.0765 11.4019 16.2195 11.3427 16.3249 11.2372L23.0749 4.48717C23.2945 4.2677 23.2946 3.91174 23.0753 3.69213C23.0752 3.69213 23.0752 3.69186 23.0749 3.69172ZM15.6944 10.277H14.2397V8.82247L20.4272 2.63497L21.8818 4.08951L15.6944 10.277Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M19.9716 1.29172H19.9673L19.9234 1.33565L13.1736 8.08572C13.0398 8.21931 12.9649 8.40048 12.9649 8.58938V10.8395C12.9649 11.2329 13.2838 11.5519 13.6772 11.5519H15.9274C16.1163 11.5519 16.2974 11.4769 16.431 11.3432L23.1809 4.59327C23.1809 4.59326 23.1809 4.59325 23.181 4.59324C23.4584 4.31594 23.4593 3.86665 23.1836 3.58828C23.1822 3.58679 23.1807 3.58531 23.1791 3.58383L23.1375 3.54213H23.1374L20.9309 1.33568C20.9308 1.33567 20.9308 1.33566 20.9308 1.33565C20.6683 1.07304 20.2514 1.05818 19.9716 1.29172ZM21.6696 4.08951L15.6323 10.127H14.3897V8.8846L20.4272 2.8471L21.6696 4.08951Z"
        stroke="#838383"
        strokeOpacity="0.54"
        strokeWidth="0.3"
      />
      <path
        d="M21.5521 8.02697C21.2416 8.02697 20.9898 8.27877 20.9898 8.58933V16.4643C20.9888 17.3959 20.2338 18.1509 19.3023 18.152H13.6772C13.5555 18.1517 13.437 18.1912 13.3397 18.2644L9.73975 20.9645V18.7145C9.73975 18.4038 9.48794 18.152 9.17725 18.152H3.55225C2.62071 18.1509 1.86571 17.3959 1.86488 16.4645V6.33933C1.86585 5.40793 2.62071 4.65293 3.55225 4.65196H13.6772C13.9879 4.65196 14.2397 4.40016 14.2397 4.08946C14.2397 3.7789 13.9879 3.5271 13.6772 3.5271H3.55225C1.99959 3.52861 0.74126 4.78695 0.739746 6.33933V16.4645C0.74126 18.017 1.99959 19.2753 3.55225 19.277H8.61475V22.0895C8.61475 22.4 8.86655 22.6518 9.17725 22.6518C9.29902 22.6518 9.41736 22.6124 9.51478 22.5394L13.8653 19.2768H19.3023C20.8549 19.2753 22.1131 18.017 22.1148 16.4643V8.58947C22.1148 8.27877 21.8628 8.02697 21.5521 8.02697Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M3.5521 3.3771L3.55225 3.3771L13.6772 3.3771C14.0708 3.3771 14.3897 3.69604 14.3897 4.08946C14.3897 4.483 14.0708 4.80196 13.6772 4.80196H3.5524C2.70359 4.80284 2.01576 5.49079 2.01488 6.33948V16.4643C2.01564 17.313 2.70357 18.001 3.55242 18.002H9.17725C9.57079 18.002 9.88975 18.3209 9.88975 18.7145V20.6645L13.2495 18.1445C13.2496 18.1445 13.2496 18.1445 13.2496 18.1445C13.373 18.0517 13.5232 18.0016 13.6776 18.002M3.5521 3.3771L13.6772 18.152M3.5521 3.3771C1.91673 3.37869 0.59134 4.70406 0.589746 6.33918V6.33933L0.589746 16.4645L0.589746 16.4646C0.59134 18.0999 1.91672 19.4252 3.55209 19.427H3.55225H8.46475V22.0895C8.46475 22.4829 8.78373 22.8018 9.17725 22.8018C9.33151 22.8018 9.48137 22.7518 9.60467 22.6595L9.60477 22.6594L13.9153 19.4268H19.3023H19.3024C20.9378 19.4252 22.263 18.0999 22.2648 16.4645V16.4643V8.58947C22.2648 8.19588 21.9456 7.87697 21.5521 7.87697C21.1587 7.87697 20.8398 8.19593 20.8398 8.58933V16.4642C20.8389 17.313 20.1509 18.001 19.3021 18.002M3.5521 3.3771L19.3023 18.152M13.6776 18.002L13.6772 18.152M13.6776 18.002H13.6772V18.152M13.6776 18.002H19.3021M13.6772 18.152H19.3023M19.3021 18.002L19.3023 18.152M19.3021 18.002H19.3023V18.152M9.88975 20.852L9.73975 20.9645V20.777L9.88975 20.852Z"
        stroke="#838383"
        strokeOpacity="0.54"
        strokeWidth="0.3"
      />
      <path
        d="M10.3021 6.90198H4.67738C4.36655 6.90198 4.11475 7.15378 4.11475 7.46448C4.11475 7.77504 4.36655 8.02684 4.67738 8.02684H10.3021C10.6128 8.02684 10.8647 7.77504 10.8647 7.46448C10.8647 7.15378 10.6128 6.90198 10.3021 6.90198Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M10.3021 6.75198H4.67738C4.28373 6.75198 3.96475 7.07092 3.96475 7.46448C3.96475 7.85793 4.28375 8.17684 4.67738 8.17684H10.3021C10.6956 8.17684 11.0147 7.85795 11.0147 7.46448C11.0147 7.07089 10.6956 6.75198 10.3021 6.75198Z"
        stroke="#838383"
        strokeOpacity="0.54"
        strokeWidth="0.3"
      />
      <path
        d="M4.67738 11.402H10.3021C10.6128 11.402 10.8647 11.15 10.8647 10.8395C10.8647 10.5288 10.6128 10.277 10.3021 10.277H4.67738C4.36655 10.277 4.11475 10.5288 4.11475 10.8395C4.11475 11.15 4.36655 11.402 4.67738 11.402Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M4.67738 11.552H10.3021C10.6956 11.552 11.0147 11.2329 11.0147 10.8395C11.0147 10.4459 10.6956 10.127 10.3021 10.127H4.67738C4.28373 10.127 3.96475 10.4459 3.96475 10.8395C3.96475 11.2329 4.28371 11.552 4.67738 11.552Z"
        stroke="#838383"
        strokeOpacity="0.54"
        strokeWidth="0.3"
      />
      <path
        d="M4.67738 14.7769H18.1773C18.4879 14.7769 18.7396 14.5251 18.7396 14.2144C18.7396 13.9039 18.4878 13.6521 18.1773 13.6521H4.67738C4.36655 13.6521 4.11475 13.9039 4.11475 14.2144C4.11475 14.5251 4.36655 14.7769 4.67738 14.7769Z"
        fill="#838383"
        fillOpacity="0.54"
      />
      <path
        d="M4.67738 14.9269H18.1773C18.5708 14.9269 18.8896 14.6079 18.8896 14.2144C18.8896 13.8211 18.5706 13.5021 18.1773 13.5021H4.67738C4.28376 13.5021 3.96475 13.821 3.96475 14.2144C3.96475 14.608 4.28374 14.9269 4.67738 14.9269Z"
        stroke="#838383"
        strokeOpacity="0.54"
        strokeWidth="0.3"
      />
    </svg>
  ),
  VerifyBadge: ({ className, onClick, width, height, fill }) => (
    <svg
      width={width}
      height={height}
      fill={fill}
      onClick={onClick}
      height="19"
      className={className}
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 9.5L17.7359 6.98985L18.0904 3.62941L14.7797 2.92952L13.0909 0L10 1.3794L6.9091 0L5.22032 2.92952L1.90964 3.62941L2.26409 6.98985L0 9.5L2.26405 12.0101L1.9096 15.3706L5.22028 16.0705L6.90906 19L9.99998 17.6206L13.0909 19L14.7797 16.0705L18.0904 15.3706L17.7359 12.0101L20 9.5ZM10 16.3373L7.39747 17.4988L5.97581 15.0327L3.18725 14.4431L3.48566 11.6139L1.57908 9.50004L3.48566 7.38622L3.18725 4.55695L5.97581 3.96743L7.39747 1.50129L10 2.66273L12.6025 1.50129L14.0242 3.96743L16.8128 4.55695L16.5144 7.38622L18.4209 9.5L16.5143 11.6138L16.8128 14.443L14.0242 15.0326L12.6025 17.4987L10 16.3373Z"
        fill="#D8000D"
      />
      <path
        d="M13.317 6.53333L9.12421 11.2239L6.51423 8.61766L5.68459 9.44612L9.17267 12.9292L14.1923 7.31352L13.317 6.53333Z"
        fill="#D8000D"
      />
    </svg>
  ),
  ArrowLeftIcon: ({ className }) => (
    <svg
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.4 1.4L6 0L0 6L6 12L7.4 10.6L2.8 6L7.4 1.4Z"
        fill="#D8000D"
      />
    </svg>
  ),
  ArrowLeftIconGray: ({
    className,
    onClick,
    width = '8',
    height = '12',
    fill = '#AEAEAE',
  }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.4 1.4L6 0L0 6L6 12L7.4 10.6L2.8 6L7.4 1.4Z"
        fill={fill}
      />
    </svg>
  ),
  ArrowLeftIconGraySort: () => (
    <svg
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.4 1.4L6 0L0 6L6 12L7.4 10.6L2.8 6L7.4 1.4Z"
        fill="#AEAEAE"
      />
    </svg>
  ),
  MusicsIcon: () => (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.1356 23.9746C29.9526 23.8339 29.7136 23.7888 29.4793 23.851L26.8787 24.542C26.4751 24.6492 26.1707 25.0505 26.1707 25.4756V28.7468C25.961 28.6585 25.7271 28.609 25.4804 28.609C24.5827 28.609 23.8524 29.2622 23.8524 30.065C23.8524 30.868 24.5827 31.5212 25.4804 31.5212C26.3779 31.5212 27.1082 30.868 27.1082 30.065C27.1082 30.0447 27.1082 27.1425 27.1082 27.1425L29.72 26.4479C30.1236 26.3407 30.4279 25.9394 30.4279 25.5142V24.5918C30.4279 24.3424 30.3214 24.1175 30.1356 23.9746ZM25.4804 30.5836C25.1061 30.5836 24.7899 30.3461 24.7899 30.065C24.7899 29.7839 25.1061 29.5464 25.4804 29.5464C25.8546 29.5464 26.1707 29.7839 26.1707 30.065C26.1707 30.3461 25.8546 30.5836 25.4804 30.5836ZM29.4686 25.5445L27.1082 26.1724L27.1079 25.4802C27.1097 25.4704 27.1208 25.4532 27.13 25.4452L29.4904 24.8181L29.4907 25.5094C29.4889 25.5193 29.4778 25.5365 29.4686 25.5445Z"
        fill="#FF3C45"
      />
      <path
        d="M30.6522 9.31477C30.5347 9.08408 30.2524 8.99233 30.0218 9.10971C29.7911 9.22714 29.6993 9.50939 29.8167 9.74008C31.4835 13.0146 31.4835 18.3426 29.8167 21.617C29.6993 21.8477 29.7911 22.1299 30.0218 22.2474C30.0899 22.2821 30.1626 22.2985 30.2341 22.2985C30.4047 22.2985 30.5694 22.2049 30.6521 22.0423C31.5212 20.3348 31.9999 18.0748 31.9999 15.6785C31.9999 13.2823 31.5213 11.0223 30.6522 9.31477Z"
        fill="#FF3C45"
      />
      <path
        d="M28.533 19.3205C28.6011 19.3552 28.6737 19.3716 28.7453 19.3716C28.916 19.3716 29.0807 19.2779 29.1634 19.1153C30.1443 17.1877 30.1443 14.1677 29.1634 12.24C29.046 12.0093 28.7637 11.9173 28.533 12.0348C28.3023 12.1522 28.2105 12.4345 28.3278 12.6652C29.1731 14.3263 29.1731 17.029 28.3278 18.6901C28.2105 18.9208 28.3023 19.2031 28.533 19.3205Z"
        fill="#FF3C45"
      />
      <path
        d="M24.1826 7.49492C21.9974 5.30879 19.0914 4.10492 15.9997 4.10492C12.9081 4.10492 10.0016 5.30879 7.81548 7.49492C3.30498 12.0074 3.30498 19.3497 7.8156 23.8622C9.71979 25.7656 12.2419 26.9514 14.9172 27.2012C15.2755 27.2347 15.634 27.2512 15.9919 27.2512C18.2714 27.2512 20.5177 26.5785 22.4137 25.313C22.629 25.1693 22.687 24.8782 22.5433 24.6629C22.3995 24.4475 22.1084 24.3896 21.8932 24.5333C17.6962 27.3349 12.0545 26.7737 8.47848 23.1994C4.33329 19.0524 4.33329 12.3047 8.47841 8.15779C10.4874 6.14879 13.1584 5.04242 15.9996 5.04242C18.8408 5.04242 21.5114 6.14873 23.5195 8.15779C27.6664 12.3048 27.6664 19.0523 23.5195 23.1992C23.3364 23.3824 23.3364 23.6791 23.5195 23.8622C23.7026 24.0452 23.9994 24.0452 24.1824 23.8622C28.6949 19.3497 28.6949 12.0074 24.1826 7.49492Z"
        fill="#FF3C45"
      />
      <path
        d="M10.3526 9.88411C10.538 9.70336 10.5418 9.40661 10.3611 9.22123C10.1804 9.0358 9.88361 9.03211 9.6983 9.21274C7.94011 10.9265 6.9718 13.2224 6.9718 15.6776C6.9718 20.656 11.0219 24.7062 16.0002 24.7062C20.9784 24.7062 25.0285 20.656 25.0285 15.6776C25.0285 10.6992 20.9783 6.64905 16.0001 6.64905C14.4103 6.64905 12.8464 7.06874 11.4772 7.86274C11.2533 7.99261 11.1771 8.27948 11.3069 8.50342C11.4369 8.72736 11.7237 8.80367 11.9476 8.6738C13.1739 7.96249 14.5752 7.58655 16.0001 7.58655C20.4614 7.58655 24.0909 11.2162 24.0909 15.6777C24.0909 20.1391 20.4614 23.7687 16.0001 23.7687C11.5387 23.7687 7.90918 20.1391 7.90918 15.6777C7.90924 13.4774 8.77699 11.4199 10.3526 9.88411Z"
        fill="#FF3C45"
      />
      <path
        d="M2.36196 3.66544L3.50534 4.24501L4.0854 5.38951C4.21584 5.64513 4.39677 5.77476 4.62321 5.77476H4.62452C4.78059 5.77438 5.00046 5.70701 5.16134 5.38832L5.74084 4.24501L6.88346 3.66576C7.14071 3.53588 7.27115 3.35469 7.27121 3.12732C7.27121 2.89982 7.14084 2.71863 6.88415 2.58901L5.74084 2.00951L5.16159 0.866694C5.03184 0.609882 4.85096 0.479382 4.6239 0.478882C4.62352 0.478882 4.62309 0.478882 4.62271 0.478882C4.46677 0.478882 4.24746 0.545757 4.08471 0.864632L3.50527 2.00957L2.36252 2.58876C2.04327 2.75007 1.9759 2.96994 1.97559 3.12601C1.97515 3.35294 2.10484 3.53432 2.36196 3.66544ZM4.06602 2.77638C4.15502 2.73126 4.22727 2.65894 4.27234 2.56994L4.62284 1.87744L4.97396 2.57019C5.01902 2.65913 5.09121 2.73132 5.18015 2.77638L5.8724 3.12726L5.18009 3.47819C5.09121 3.52326 5.01896 3.59544 4.9739 3.68438L4.62302 4.37663L4.27221 3.68438C4.22715 3.59544 4.15496 3.52326 4.06602 3.47819L3.37371 3.12726L4.06602 2.77638Z"
        fill="#FF3C45"
      />
      <path
        d="M24.6543 4.56494H25.1208C25.3798 4.56494 25.5896 4.35513 25.5896 4.09619C25.5896 3.83725 25.3798 3.62744 25.1208 3.62744H24.6543C24.3954 3.62744 24.1856 3.83725 24.1856 4.09619C24.1856 4.35513 24.3954 4.56494 24.6543 4.56494Z"
        fill="#FF3C45"
      />
      <path
        d="M27.2112 4.56494H27.6777C27.9366 4.56494 28.1464 4.35513 28.1464 4.09619C28.1464 3.83725 27.9366 3.62744 27.6777 3.62744H27.2112C26.9522 3.62744 26.7424 3.83725 26.7424 4.09619C26.7424 4.35513 26.9522 4.56494 27.2112 4.56494Z"
        fill="#FF3C45"
      />
      <path
        d="M26.1659 6.07667C26.4248 6.07667 26.6347 5.86686 26.6347 5.60792V5.14142C26.6347 4.88248 26.4248 4.67267 26.1659 4.67267C25.907 4.67267 25.6972 4.88248 25.6972 5.14142V5.60792C25.6972 5.86679 25.907 6.07667 26.1659 6.07667Z"
        fill="#FF3C45"
      />
      <path
        d="M26.1659 3.51969C26.4248 3.51969 26.6347 3.30988 26.6347 3.05094V2.58444C26.6347 2.3255 26.4248 2.11569 26.1659 2.11569C25.907 2.11569 25.6972 2.3255 25.6972 2.58444V3.05094C25.6972 3.30988 25.907 3.51969 26.1659 3.51969Z"
        fill="#FF3C45"
      />
      <path
        d="M7.34559 26.7921H6.87915C6.62028 26.7921 6.4104 27.002 6.4104 27.2609C6.4104 27.5198 6.62028 27.7296 6.87915 27.7296H7.34559C7.60446 27.7296 7.81434 27.5198 7.81434 27.2609C7.81434 27.002 7.60446 26.7921 7.34559 26.7921Z"
        fill="#FF3C45"
      />
      <path
        d="M4.78893 26.7921H4.3225C4.06362 26.7921 3.85374 27.002 3.85374 27.2609C3.85374 27.5198 4.06362 27.7296 4.3225 27.7296H4.78893C5.04781 27.7296 5.25769 27.5198 5.25769 27.2609C5.25769 27.002 5.04781 26.7921 4.78893 26.7921Z"
        fill="#FF3C45"
      />
      <path
        d="M5.83409 25.2787C5.57522 25.2787 5.36534 25.4885 5.36534 25.7475V26.2157C5.36534 26.4746 5.57522 26.6844 5.83409 26.6844C6.09297 26.6844 6.30284 26.4746 6.30284 26.2157V25.7475C6.30284 25.4885 6.09297 25.2787 5.83409 25.2787Z"
        fill="#FF3C45"
      />
      <path
        d="M5.83409 27.8373C5.57522 27.8373 5.36534 28.0472 5.36534 28.3061V28.7725C5.36534 29.0315 5.57522 29.2413 5.83409 29.2413C6.09297 29.2413 6.30284 29.0315 6.30284 28.7725V28.3061C6.30284 28.0472 6.09297 27.8373 5.83409 27.8373Z"
        fill="#FF3C45"
      />
      <path
        d="M17.9351 14.9571C17.0061 15.1285 16.2783 15.8579 16.2783 16.6176C16.2783 16.9656 16.4276 17.2816 16.6987 17.5072C16.9638 17.7279 17.3221 17.8444 17.7166 17.8444C17.8431 17.8444 17.9734 17.8324 18.1055 17.8081C19.0335 17.6364 19.7604 16.9071 19.7604 16.1476V12.0948C19.7604 12.0781 19.7595 12.0617 19.7578 12.0455C19.7448 11.83 19.6478 11.6313 19.4854 11.4948C19.3041 11.3423 19.0584 11.2796 18.8099 11.3228L14.5218 12.0837C14.0799 12.1608 13.7338 12.5625 13.7338 12.998V16.9467C13.4648 16.8689 13.1599 16.8559 12.8444 16.9143C11.9153 17.0856 11.1875 17.815 11.1875 18.5747C11.1875 18.9228 11.3368 19.2388 11.6078 19.4643C11.873 19.6851 12.2313 19.8016 12.6257 19.8016C12.7522 19.8016 12.8825 19.7896 13.0145 19.7652C13.9436 19.5938 14.6714 18.8644 14.6714 18.1048V14.6903L18.823 13.9536V14.9893C18.5543 14.9117 18.2501 14.8988 17.9351 14.9571ZM17.9351 16.8863C17.6231 16.9438 17.4016 16.8726 17.2984 16.7868C17.2412 16.7392 17.2158 16.687 17.2158 16.6176C17.2158 16.3464 17.5962 15.9731 18.1052 15.8791H18.1054C18.1837 15.8646 18.2562 15.8583 18.3226 15.8583C18.5199 15.8583 18.663 15.9143 18.7401 15.9783C18.7974 16.0259 18.8229 16.0782 18.8229 16.1477C18.8229 16.4188 18.4431 16.7923 17.9351 16.8863ZM12.8443 18.8434C12.532 18.9008 12.3106 18.8297 12.2076 18.7439C12.1504 18.6963 12.125 18.6441 12.125 18.5748C12.125 18.3036 12.5054 17.9302 13.0144 17.8362C13.093 17.8218 13.1658 17.8154 13.2324 17.8154C13.4306 17.8154 13.574 17.8714 13.6512 17.9357C13.7084 17.9833 13.7338 18.0354 13.7338 18.1048C13.7337 18.376 13.3534 18.7494 12.8443 18.8434ZM14.6713 13.7383V13.0173C14.6753 13.0128 14.6809 13.0083 14.6842 13.0071L18.8229 12.2728V13.0015L14.6713 13.7383Z"
        fill="#FF3C45"
      />
      <path
        d="M2.18331 9.74006C2.30075 9.50937 2.20894 9.22712 1.97819 9.10969C1.74744 8.99231 1.46525 9.084 1.34781 9.31475C0.478688 11.0222 0 13.2823 0 15.6785C0 18.0747 0.478688 20.3347 1.34781 22.0422C1.43056 22.2049 1.59519 22.2985 1.76594 22.2985C1.8375 22.2985 1.91012 22.282 1.97819 22.2474C2.20887 22.1299 2.30075 21.8477 2.18331 21.617C0.516562 18.3425 0.516562 13.0145 2.18331 9.74006Z"
        fill="#FF3C45"
      />
      <path
        d="M3.46504 12.0346C3.23416 11.9174 2.95204 12.0096 2.83485 12.2403C1.85591 14.1679 1.85591 17.1876 2.83485 19.115C2.91754 19.2777 3.08223 19.3716 3.25316 19.3716C3.32454 19.3716 3.39704 19.3551 3.46504 19.3206C3.69585 19.2034 3.78798 18.9212 3.67073 18.6904C2.82698 17.0292 2.82698 14.3261 3.67073 12.6649C3.78791 12.434 3.69585 12.1519 3.46504 12.0346Z"
        fill="#FF3C45"
      />
    </svg>
  ),
  FootballIcon: () => (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.97969 1.87555C7.9948 2.68028 6.21376 3.8635 4.68652 5.39028C3.15883 6.9175 1.97692 8.69896 1.17174 10.6834C0.394412 12.6006 0 14.6266 0 16.7047C0 18.7824 0.394412 20.8084 1.17174 22.7247C1.97692 24.7096 3.15928 26.491 4.68652 28.0178C6.21376 29.5455 7.99436 30.7278 9.97969 31.5325C11.8969 32.3107 13.9225 32.7038 16.0007 32.7038C18.0788 32.7038 20.104 32.3094 22.0212 31.5325C24.0056 30.7278 25.7876 29.5455 27.3144 28.0178C28.842 26.491 30.0244 24.7105 30.8291 22.7247C31.6065 20.8084 32 18.7824 32 16.7047C32 14.6266 31.606 12.6006 30.8291 10.6834C30.0244 8.69896 28.8412 6.91706 27.3144 5.39028C25.7876 3.8635 24.0074 2.68028 22.0212 1.87555C20.104 1.09868 18.0788 0.704712 16.0007 0.704712C13.9225 0.704712 11.8969 1.09868 9.97969 1.87555ZM3.99895 23.4401C3.22825 22.9564 2.51814 22.3993 1.88938 21.7431C0.928991 19.0406 0.766274 16.1149 1.40255 13.3377C1.7019 12.7474 2.04236 12.1805 2.42749 11.6376C2.54643 11.47 2.65653 11.2953 2.78388 11.1326L6.39461 13.2691C6.39461 13.2974 6.39461 13.3284 6.39461 13.3598C6.38532 15.3017 6.58253 17.2296 6.97517 19.1295C6.9765 19.1384 6.97782 19.1432 6.97959 19.1512L4.17935 23.5418C4.11833 23.5109 4.05776 23.4773 3.99895 23.4401ZM14.7347 30.8627C15.3578 31.1806 15.9985 31.449 16.6568 31.6674C13.8601 31.789 11.0356 31.1337 8.53867 29.7011L14.5915 30.7795C14.6379 30.8092 14.6852 30.8375 14.7347 30.8627ZM14.7126 29.7701L7.56988 28.4971C6.73419 27.4824 5.98251 26.4088 5.3365 25.2614C5.17202 24.9696 4.98852 24.6861 4.84924 24.3815L7.64682 19.9953C7.70872 20.0107 7.7777 20.0271 7.85596 20.0479C9.60606 20.5161 11.3871 20.8491 13.1805 21.11C13.2853 21.1245 13.3729 21.1374 13.4476 21.1453L16.801 26.9434C16.2191 27.7614 15.6306 28.5749 15.0292 29.3797C14.9293 29.5136 14.8232 29.6423 14.7126 29.7701ZM26.5963 27.3002C26.0277 27.8692 25.4241 28.3822 24.7923 28.8393C24.6875 28.0019 24.5066 27.1812 24.2515 26.3796L27.8295 19.7048C28.8151 19.256 29.7657 18.747 30.6483 18.1161C30.7637 18.0343 30.8597 17.9428 30.9339 17.8428C30.6748 21.2921 29.2289 24.668 26.5963 27.3002ZM26.4376 18.6436C26.5706 18.8974 26.702 19.1538 26.8337 19.4138L23.3778 25.8605C23.3579 25.8649 23.3389 25.8694 23.319 25.872C21.4508 26.2209 19.5676 26.4066 17.6685 26.4154L14.2196 20.452C14.7564 19.4554 15.2883 18.4548 15.8158 17.4537C16.174 16.7746 16.526 16.091 16.8775 15.4079L24.0154 14.6748C24.8895 15.957 25.7177 17.2667 26.4376 18.6436ZM24.9895 10.9969C24.6508 11.8914 24.2882 12.7766 23.9278 13.6635L16.9743 14.3776C16.8912 14.268 16.805 14.1601 16.7143 14.0571C15.8932 13.1272 15.0668 12.2031 14.2417 11.2763C14.2492 11.267 14.2568 11.26 14.2643 11.2516C13.9313 10.919 13.5975 10.5865 13.2645 10.2532L15.2003 4.42505C15.3339 4.38967 15.4683 4.36005 15.604 4.34546C16.6564 4.23845 17.7101 4.1173 18.7651 4.05628C19.4111 4.02003 20.0606 3.99925 20.7177 4.04567L25.5072 9.444C25.3423 9.96487 25.1814 10.4871 24.9895 10.9969ZM26.5963 6.10835C27.9175 7.43041 28.9407 8.93906 29.664 10.5507C28.7691 9.9348 27.8122 9.42809 26.8063 9.01511C26.6498 8.95055 26.4893 8.89351 26.3261 8.83736L21.6117 3.52392C21.6445 3.29444 21.6617 3.06452 21.6688 2.83283C23.4622 3.56283 25.1433 4.65585 26.5963 6.10835ZM11.2018 2.55382C11.2204 2.56753 11.2292 2.57903 11.2399 2.58212C12.3174 2.95442 13.2977 3.5027 14.2218 4.15312L12.4134 9.5992C12.4041 9.60185 12.3952 9.60451 12.3864 9.60849C12.0163 9.76147 11.6391 9.89854 11.2748 10.0644C9.77364 10.7466 8.31007 11.5023 6.9314 12.4082L3.36267 10.2969C3.36798 10.1855 3.38699 10.0723 3.42502 9.9715C3.66467 9.33302 3.90035 8.691 4.17139 8.06535C4.3801 7.58339 4.61798 7.1178 4.87753 6.66282C5.04733 6.47534 5.22331 6.28963 5.4046 6.10835C7.09942 4.41399 9.10243 3.21087 11.235 2.49944C11.2239 2.51668 11.2124 2.53481 11.2018 2.55382Z"
        fill="#FF3C45"
      />
    </svg>
  ),
  HeadphoneIcon: () => (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_171:3257)">
        <path
          d="M28.75 18.9068V16C28.75 13.4773 27.9984 11.0868 26.5697 9.04156C27.1881 7.9365 27.0249 6.51 26.0411 5.612C23.4457 3.24244 20.0573 1.9375 16.5 1.9375C12.9427 1.9375 9.55431 3.24244 6.95881 5.612C5.97513 6.51 5.81188 7.93637 6.43025 9.04156C5.00163 11.0868 4.25 13.4773 4.25 16V18.9068C2.113 19.3424 0.5 21.2363 0.5 23.5C0.5 25.8119 2.18287 27.737 4.38762 28.1178C4.75431 29.2451 5.8145 30.0625 7.0625 30.0625C8.61331 30.0625 9.875 28.8008 9.875 27.25V19.75C9.875 18.1992 8.61331 16.9375 7.0625 16.9375C6.73387 16.9375 6.41844 16.9947 6.125 17.0987V16C6.125 13.9351 6.71987 11.9753 7.85244 10.2836C8.85925 10.6731 10.0024 10.4351 10.8166 9.70719C12.3414 8.34419 14.4129 7.5625 16.5 7.5625C18.5871 7.5625 20.6586 8.34419 22.1833 9.70719C23.0093 10.4454 24.1529 10.6674 25.1473 10.2832C26.28 11.9751 26.875 13.9349 26.875 16V17.0987C26.5816 16.9947 26.2661 16.9375 25.9375 16.9375C24.3867 16.9375 23.125 18.1992 23.125 19.75V27.25C23.125 28.8008 24.3867 30.0625 25.9375 30.0625C27.1855 30.0625 28.2457 29.2451 28.6124 28.1178C30.8171 27.737 32.5 25.8119 32.5 23.5C32.5 21.2363 30.887 19.3424 28.75 18.9068ZM4.25 26.1518C3.15869 25.7649 2.375 24.7222 2.375 23.5C2.375 22.2778 3.15869 21.2351 4.25 20.8481C4.25 21.4944 4.25 25.5061 4.25 26.1518ZM7.0625 18.8125C7.57944 18.8125 8 19.2331 8 19.75V27.25C8 27.7669 7.57944 28.1875 7.0625 28.1875C6.54556 28.1875 6.125 27.7669 6.125 27.25C6.125 26.9204 6.125 20.0789 6.125 19.75C6.125 19.2331 6.54556 18.8125 7.0625 18.8125ZM24.7995 8.30981C24.7666 8.337 24.7363 8.36606 24.7081 8.39662C24.3509 8.6855 23.8191 8.6545 23.4329 8.30931C21.5416 6.61856 19.0794 5.6875 16.5 5.6875C13.9206 5.6875 11.4585 6.61856 9.56706 8.30925C9.18081 8.65444 8.64906 8.68544 8.29187 8.3965C8.26362 8.36606 8.23338 8.33694 8.2005 8.30975C7.85325 7.93781 7.84731 7.33969 8.223 6.99662C10.4722 4.94331 13.4116 3.8125 16.5 3.8125C19.5883 3.8125 22.5278 4.94331 24.777 6.99669C25.1528 7.33962 25.1467 7.93787 24.7995 8.30981ZM26.875 27.25C26.875 27.7669 26.4544 28.1875 25.9375 28.1875C25.4206 28.1875 25 27.7669 25 27.25V19.75C25 19.2331 25.4206 18.8125 25.9375 18.8125C26.4544 18.8125 26.875 19.2331 26.875 19.75C26.875 19.848 26.875 27.1502 26.875 27.25ZM28.75 26.1519C28.75 25.5034 28.75 21.4351 28.75 20.8482C29.8413 21.2351 30.625 22.2778 30.625 23.5001C30.625 24.7223 29.8413 25.7649 28.75 26.1519Z"
          fill="#FF3C45"
        />
        <path
          d="M20.2071 18.7317C19.4989 17.8246 18.5367 17.2372 17.4375 17.0257V16C17.4375 15.4822 17.0177 15.0625 16.5 15.0625C15.9823 15.0625 15.5625 15.4822 15.5625 16V22.7237C15.2691 22.6197 14.9536 22.5625 14.625 22.5625C13.0742 22.5625 11.8125 23.8242 11.8125 25.375C11.8125 26.9258 13.0742 28.1875 14.625 28.1875C16.1758 28.1875 17.4375 26.9258 17.4375 25.375V18.9591C18.0492 19.1634 18.4647 19.5468 18.7292 19.8856C19.4207 20.7713 19.6493 22.0375 19.3405 23.2726C19.1928 23.8633 19.6396 24.4377 20.2507 24.4377C20.6707 24.4377 21.053 24.1534 21.1595 23.7274C21.6073 21.9365 21.2511 20.0689 20.2071 18.7317ZM14.625 26.3125C14.1081 26.3125 13.6875 25.8919 13.6875 25.375C13.6875 24.8581 14.1081 24.4375 14.625 24.4375C15.1419 24.4375 15.5625 24.8581 15.5625 25.375C15.5625 25.8919 15.1419 26.3125 14.625 26.3125Z"
          fill="#FF3C45"
        />
      </g>
      <defs>
        <clipPath id="clip0_171:3257">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  LogoText: () => (
    <svg
      width="97"
      height="26"
      viewBox="0 0 97 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width="97" height="26" fill="url(#pattern0)" />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_130:4890"
            transform="translate(0 -0.173077) scale(0.0103093 0.0384615)"
          />
        </pattern>
        <image
          id="image0_130:4890"
          width="97"
          height="35"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGEAAAAjCAYAAACElmTEAAAEQklEQVRoBe2XsY4cVRBFHZKTkBORkpESOiQkJCUidkRO4twJH4DkH0DiCxBfgJAQQlgII8uyjCw01mnprs7c7de7s7M73UE/yXrd++rdulW3qnr86LCv1TPwaHUGO4HDLsIGimAXYRdhAxnYAIXZTnj362+HV989Pfzx0ceH3z/48Orf319+dXjzw/Mhbdu+fvb9kR14Of/zk0+Pzu7r5f+XLyfef332+ZWv+Pz3ybeH5mS/l+Bnf36+JoLJJIDeXzz+4kDAvWzXARv3IUTAn/2PnvH938+/NPVJvNx5CH7XHOoPRyI4USE02qm2Xra9pAin8A7HFsIYq4kAqRDMDrEszumAnLH7HDuftQjBue+djuyxyejxgjuj1PyIxWsTInSCR7Pf85bgPZYc5KVEePvjT0fJ7cJwookRMbAxb2xWF4EPsRPYVeJAOmiLZYwWYSlIn8V3Vy8jArte+Fny2/ajd3PIOGoO+Jnj0Jhw6qLmvXOSe9M3wQRu48jd4NZfSoZ9JMiQ8BlkEdZYfqaSvUiUz+FGUZ26zAF+jds+5vDpLufGd/JMfN2Fkwg9LyGwtEgSpHvFEXur3kH6bp/1jDcuz+2bpLVNxs5NsYRHc5jDtA9PgGDcJEDuY+c1idCt00r5wtJznLDfVYRgONFOEOeI5LXUOcEjRnBGsbUP7i1x+Ofrb0xhso0vdoogvti70J2fSYRW/Qj9hBeTsBMgHCT+vHzWwceOoI3flci36raV6BEa/NtwMD6ierl7+yx2zrO7YZMipIJCnr1ntKvUdvnffifVAvJMZXq1/RwHF4ITvfRjZclHvl2bG0fdJQ7CiexxYLt+pmt6HIBF8rIswojDSAS63txG36Eem/E/iWBwwEYgITzaTeSu42iUAHwa/xQRwpcxZAyPpXNE8F3wU+Hxm7075kiEBuF9abmqnAwH+NAiOIFLXH3WI80jxTkYFYKL1XfvpRNQzgm0AwfBc9taMGPcVQQw5lYnEL+j9p67P8fd34VzRGhu/aMhfOyDOPPdmcYRRiTeSXRyA8LuLsDeref754gw57tHSUYmVRu//sVhznnuJNiPz07tBPDP/nUESKtJYG55kt0CeBSBkWSwnyMC90cJ4sxJ6lGAEO0b7h4l4ekCOlcE3wefXKXS8dNFbo5XnUASGyhk53aCjRPusmxnJ5wZ20nsMyrKVWXMPDf2XIJjO9rh47XEL3b2Mzey3ZUjv/zdYxDsIxH4g8mMgCDQAnDX9p0o4y6JwBl3jeXn7r4kyPi272cEnpvZvt/84uMmEaj4m4RoAcC+JgJ/ZDSZVAKBxFwAIRk79nNEAA8/dFswI058ze0UBrx9L/fhztloOd67ihBssFqMpdzNihCwS+23ScCluKzhZxdhjayXz12ESsgar7sIa2S9fO4iVELWeN2ECGsEviWfuwgbUGMXYRdhAxnYAIW9EzYgwnv1x4HrAbljkgAAAABJRU5ErkJggg=="
        />
      </defs>
    </svg>
  ),
  MoreIcon: ({ onClick, className, fill = '#898989' }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      width="20"
      onClick={onClick}
      className={className}
    >
      <path
        d="M12 20q-.825 0-1.412-.587Q10 18.825 10 18q0-.825.588-1.413Q11.175 16 12 16t1.413.587Q14 17.175 14 18q0 .825-.587 1.413Q12.825 20 12 20Zm0-6q-.825 0-1.412-.588Q10 12.825 10 12t.588-1.413Q11.175 10 12 10t1.413.587Q14 11.175 14 12q0 .825-.587 1.412Q12.825 14 12 14Zm0-6q-.825 0-1.412-.588Q10 6.825 10 6t.588-1.412Q11.175 4 12 4t1.413.588Q14 5.175 14 6t-.587 1.412Q12.825 8 12 8Z"
        fill={fill}
        // fill-opacity="0.54"
      />
    </svg>
    // <svg
    //   width='4'
    //   height='17'
    //   viewBox='0 0 4 17'
    //   fill='none'
    //   xmlns='http://www.w3.org/2000/svg'
    // >
    //   <path
    //     fillRule='evenodd'
    //     clipRule='evenodd'
    //     d='M2 4.45921C3.1 4.45921 4 3.55921 4 2.45921C4 1.35921 3.1 0.459213 2 0.459213C0.9 0.459213 0 1.35921 0 2.45921C0 3.55921 0.9 4.45921 2 4.45921ZM2 6.45921C0.9 6.45921 0 7.35921 0 8.45921C0 9.55921 0.9 10.4592 2 10.4592C3.1 10.4592 4 9.55921 4 8.45921C4 7.35921 3.1 6.45921 2 6.45921ZM0 14.4592C0 13.3592 0.9 12.4592 2 12.4592C3.1 12.4592 4 13.3592 4 14.4592C4 15.5592 3.1 16.4592 2 16.4592C0.9 16.4592 0 15.5592 0 14.4592Z'
    //     fill='#828282'
    //   />
    // </svg>
  ),
  NewMoreIcon: ({ onClick, className, fill = '#898989' }) => (
    <svg
      width="5"
      height="20"
      viewBox="0 0 5 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className={className}
    >
      <path
        d="M2.5 15C3.16304 15 3.79893 15.2634 4.26777 15.7322C4.73661 16.2011 5 16.837 5 17.5C5 18.163 4.73661 18.7989 4.26777 19.2678C3.79893 19.7366 3.16304 20 2.5 20C1.83696 20 1.20107 19.7366 0.732234 19.2678C0.263393 18.7989 0 18.163 0 17.5C0 16.837 0.263393 16.2011 0.732234 15.7322C1.20107 15.2634 1.83696 15 2.5 15ZM2.5 7.5C3.16304 7.5 3.79893 7.76339 4.26777 8.23223C4.73661 8.70107 5 9.33696 5 10C5 10.663 4.73661 11.2989 4.26777 11.7678C3.79893 12.2366 3.16304 12.5 2.5 12.5C1.83696 12.5 1.20107 12.2366 0.732234 11.7678C0.263393 11.2989 0 10.663 0 10C0 9.33696 0.263393 8.70107 0.732234 8.23223C1.20107 7.76339 1.83696 7.5 2.5 7.5ZM2.5 0C3.16304 0 3.79893 0.263392 4.26777 0.732233C4.73661 1.20107 5 1.83696 5 2.5C5 3.16304 4.73661 3.79893 4.26777 4.26777C3.79893 4.73661 3.16304 5 2.5 5C1.83696 5 1.20107 4.73661 0.732234 4.26777C0.263393 3.79893 0 3.16304 0 2.5C0 1.83696 0.263393 1.20107 0.732234 0.732233C1.20107 0.263392 1.83696 0 2.5 0Z"
        fill={fill}
      />
    </svg>
  ),
  closeIcon: ({
    width = '14',
    height = '14',
    onClick,
    fill = '#434343',
    className,
  }) => (
    <svg
      width={width}
      height={height}
      onClick={onClick}
      viewBox="0 0 14 14"
      fill={fill}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3 0.709987C13.1132 0.522734 12.8595 0.417501 12.595 0.417501C12.3305 0.417501 12.0768 0.522734 11.89 0.709987L7 5.58999L2.11 0.699987C1.92317 0.512734 1.66952 0.407501 1.405 0.407501C1.14048 0.407501 0.886833 0.512734 0.700001 0.699987C0.310001 1.08999 0.310001 1.71999 0.700001 2.10999L5.59 6.99999L0.700001 11.89C0.310001 12.28 0.310001 12.91 0.700001 13.3C1.09 13.69 1.72 13.69 2.11 13.3L7 8.40999L11.89 13.3C12.28 13.69 12.91 13.69 13.3 13.3C13.69 12.91 13.69 12.28 13.3 11.89L8.41 6.99999L13.3 2.10999C13.68 1.72999 13.68 1.08999 13.3 0.709987Z"
        // fill="#434343"
      />
    </svg>
  ),
  replyIcon: ({ width = '14', height = '14', onClick, fill, className }) => (
    <svg
      width={width}
      height={height}
      onClick={onClick}
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.70711 3.29289C8.09763 3.68342 8.09763 4.31658 7.70711 4.70711L5.41421 7H11C14.866 7 18 10.134 18 14V16C18 16.5523 17.5523 17 17 17C16.4477 17 16 16.5523 16 16V14C16 11.2386 13.7614 9 11 9H5.41421L7.70711 11.2929C8.09763 11.6834 8.09763 12.3166 7.70711 12.7071C7.31658 13.0976 6.68342 13.0976 6.29289 12.7071L2.29289 8.70711C1.90237 8.31658 1.90237 7.68342 2.29289 7.29289L6.29289 3.29289C6.68342 2.90237 7.31658 2.90237 7.70711 3.29289Z"
        fill={fill}
      />
    </svg>
  ),
  replyForwardIcon: ({
    width = '14',
    height = '14',
    onClick,
    className,
    fill = '#434343',
  }) => (
    // <svg
    //   width={width}
    //   height={height}
    //   onClick={onClick}
    //   className={className}
    //   fill="#434343"
    //   // className="svg-icon"
    //   // style="width: 1.099609375em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;"
    //   viewBox="0 0 1126 1024"
    //   version="1.1"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M1126.131418 368.554148a39.721726 39.721726 0 0 1-11.977944 28.818727l-321.766458 327.75543a38.339656 38.339656 0 0 1-28.306849 12.182694 38.339656 38.339656 0 0 1-28.306849-12.182694 39.465787 39.465787 0 0 1-11.977943-28.818727v-164.056872h-140.868803c-41.103797 0-77.856631 1.433258-110.207316 3.839084-32.555436 2.55939-64.752557 7.166291-96.847301 13.769516a356.983659 356.983659 0 0 0-83.487289 27.078342 301.137779 301.137779 0 0 0-66.28819 44.431003 227.222607 227.222607 0 0 0-50.266411 64.598993c-12.950511 24.979642-23.085694 54.46381-30.559112 88.708443a554.363784 554.363784 0 0 0-11.005375 115.940349c0 23.392821 1.126131 49.60097 3.122455 78.675635 0 2.55939 0.563066 7.626981 1.689197 15.049211 1.126131 7.473418 1.689197 13.052887 1.689197 16.891971 0 6.449662-1.842761 11.773192-5.221155 16.072967A18.018103 18.018103 0 0 1 120.803188 1023.757882c-6.756789 0-12.541009-3.583145-17.6086-10.903a90.755955 90.755955 0 0 1-8.34361-14.179018c-2.508202-5.425906-5.169967-12.029131-8.445986-19.348985-3.071268-7.319854-5.169967-12.438633-6.603225-15.356338C26.464088 842.809038 0 746.678365 0 675.680898c0-84.818171 11.107751-155.918014 33.37444-213.094777C101.351828 290.902268 284.501746 204.906778 583.182511 204.906778h140.766427V41.003469c0-11.056563 3.94146-20.62868 11.977943-28.818727A38.083717 38.083717 0 0 1 764.23373 0.002048c10.851812 0 20.270366 3.992648 28.306849 12.182694l321.766459 327.601867A40.950233 40.950233 0 0 1 1126.131418 368.554148z"
    //     // fill="#4A5568"
    //     fill={fill}
    //   />
    // </svg>

    <svg
      width={width}
      height={height}
      onClick={onClick}
      className={className}
      fill={fill}
      viewBox="0 0 27 19"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.875 3.8V0L0 8.86667L7.875 17.7333V13.9333L3.375 8.86667L7.875 3.8ZM14.625 5.06667V0L6.75 8.86667L14.625 17.7333V12.54C20.25 12.54 24.1875 14.5667 27 19C25.875 12.6667 22.5 6.33333 14.625 5.06667Z" />
    </svg>
  ),
  othersWatching: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon/image/remove_red_eye_24px">
        <g id="icon/image/remove_red_eye_24px_2">
          <mask
            id="path-1-outside-1_1530_29792"
            maskUnits="userSpaceOnUse"
            x="0"
            y="3.5"
            width="24"
            height="17"
            fill="black"
          >
            <rect fill="white" y="3.5" width="24" height="17" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM9 12C9 10.34 10.34 9 12 9C13.66 9 15 10.34 15 12C15 13.66 13.66 15 12 15C10.34 15 9 13.66 9 12Z"
            />
          </mask>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM9 12C9 10.34 10.34 9 12 9C13.66 9 15 10.34 15 12C15 13.66 13.66 15 12 15C10.34 15 9 13.66 9 12Z"
            fill="#838383"
            fill-opacity="0.54"
          />
          <path
            d="M1 12L0.720891 11.89L0.677546 12L0.720891 12.11L1 12ZM23 12L23.2791 12.11L23.3225 12L23.2791 11.89L23 12ZM1.27911 12.11C2.96563 7.83031 7.12782 4.8 12 4.8V4.2C6.87218 4.2 2.49437 7.38969 0.720891 11.89L1.27911 12.11ZM12 19.2C7.12782 19.2 2.96563 16.1697 1.27911 11.89L0.720891 12.11C2.49437 16.6103 6.87218 19.8 12 19.8V19.2ZM22.7209 11.89C21.0344 16.1697 16.8722 19.2 12 19.2V19.8C17.1278 19.8 21.5056 16.6103 23.2791 12.11L22.7209 11.89ZM12 4.8C16.8722 4.8 21.0344 7.83031 22.7209 12.11L23.2791 11.89C21.5056 7.38969 17.1278 4.2 12 4.2V4.8ZM6.7 12C6.7 14.9257 9.07431 17.3 12 17.3V16.7C9.40569 16.7 7.3 14.5943 7.3 12H6.7ZM12 6.7C9.07431 6.7 6.7 9.07431 6.7 12H7.3C7.3 9.40569 9.40569 7.3 12 7.3V6.7ZM17.3 12C17.3 9.07431 14.9257 6.7 12 6.7V7.3C14.5943 7.3 16.7 9.40569 16.7 12H17.3ZM12 17.3C14.9257 17.3 17.3 14.9257 17.3 12H16.7C16.7 14.5943 14.5943 16.7 12 16.7V17.3ZM12 8.7C10.1743 8.7 8.7 10.1743 8.7 12H9.3C9.3 10.5057 10.5057 9.3 12 9.3V8.7ZM15.3 12C15.3 10.1743 13.8257 8.7 12 8.7V9.3C13.4943 9.3 14.7 10.5057 14.7 12H15.3ZM12 15.3C13.8257 15.3 15.3 13.8257 15.3 12H14.7C14.7 13.4943 13.4943 14.7 12 14.7V15.3ZM8.7 12C8.7 13.8257 10.1743 15.3 12 15.3V14.7C10.5057 14.7 9.3 13.4943 9.3 12H8.7Z"
            fill="#838383"
            fill-opacity="0.54"
            mask="url(#path-1-outside-1_1530_29792)"
          />
        </g>
      </g>
    </svg>
  ),
  grayHome: () => (
    <svg
      width="30"
      height="24"
      viewBox="0 0 30 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6061 24.7992V18.795H18.3886V24.7992C18.3886 25.4596 18.9267 26 19.5843 26H23.1712C23.8288 26 24.3668 25.4596 24.3668 24.7992V16.3933H26.3994C26.9494 16.3933 27.2125 15.7088 26.794 15.3485L16.7984 6.30621C16.3441 5.89793 15.6506 5.89793 15.1963 6.30621L5.20069 15.3485C4.79417 15.7088 5.04526 16.3933 5.59525 16.3933H7.62785V24.7992C7.62785 25.4596 8.16588 26 8.82349 26H12.4104C13.068 26 13.6061 25.4596 13.6061 24.7992Z"
        fill="#BDBDBD"
      />
    </svg>
  ),
  grayHomeActive: () => (
    <svg
      width="30"
      height="24"
      viewBox="0 0 30 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6061 24.7992V18.795H18.3886V24.7992C18.3886 25.4596 18.9267 26 19.5843 26H23.1712C23.8288 26 24.3668 25.4596 24.3668 24.7992V16.3933H26.3994C26.9494 16.3933 27.2125 15.7088 26.794 15.3485L16.7984 6.30621C16.3441 5.89793 15.6506 5.89793 15.1963 6.30621L5.20069 15.3485C4.79417 15.7088 5.04526 16.3933 5.59525 16.3933H7.62785V24.7992C7.62785 25.4596 8.16588 26 8.82349 26H12.4104C13.068 26 13.6061 25.4596 13.6061 24.7992Z"
        fill="#434343"
      />
    </svg>
  ),
  navigationPlaylist: () => (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.0567 24.4722C17.0567 24.6576 16.9843 24.8355 16.8554 24.9667C16.7264 25.0978 16.5516 25.1715 16.3692 25.1715H5.6875C5.50516 25.1715 5.3303 25.0978 5.20136 24.9667C5.07243 24.8355 5 24.6576 5 24.4722C5 24.2867 5.07243 24.1088 5.20136 23.9776C5.3303 23.8465 5.50516 23.7728 5.6875 23.7728H16.3692C16.5516 23.7728 16.7264 23.8465 16.8554 23.9776C16.9843 24.1088 17.0567 24.2867 17.0567 24.4722ZM16.3692 17.8485H5.6875C5.50516 17.8485 5.3303 17.9222 5.20136 18.0534C5.07243 18.1845 5 18.3624 5 18.5479C5 18.7334 5.07243 18.9113 5.20136 19.0424C5.3303 19.1736 5.50516 19.2472 5.6875 19.2472H16.3692C16.5516 19.2472 16.7264 19.1736 16.8554 19.0424C16.9843 18.9113 17.0567 18.7334 17.0567 18.5479C17.0567 18.3624 16.9843 18.1845 16.8554 18.0534C16.7264 17.9222 16.5516 17.8485 16.3692 17.8485ZM5.6875 7.3987H26.3125C26.4948 7.3987 26.6697 7.32502 26.7986 7.19386C26.9276 7.06271 27 6.88483 27 6.69935C27 6.51387 26.9276 6.33599 26.7986 6.20483C26.6697 6.07368 26.4948 6 26.3125 6H5.6875C5.50516 6 5.3303 6.07368 5.20136 6.20483C5.07243 6.33599 5 6.51387 5 6.69935C5 6.88483 5.07243 7.06271 5.20136 7.19386C5.3303 7.32502 5.50516 7.3987 5.6875 7.3987ZM27 21.51C27 21.6308 26.9692 21.7496 26.9107 21.8547C26.8522 21.9598 26.7679 22.0477 26.666 22.1098L20.4496 25.9005C20.3453 25.9641 20.2262 25.9984 20.1046 25.9999C19.9829 26.0015 19.8631 25.9701 19.7573 25.9091C19.6514 25.8482 19.5634 25.7597 19.5021 25.6528C19.4409 25.5459 19.4086 25.4244 19.4086 25.3006V17.7194C19.4086 17.5956 19.4409 17.4741 19.5021 17.3672C19.5634 17.2603 19.6514 17.1719 19.7573 17.1109C19.8631 17.0499 19.9829 17.0185 20.1046 17.0201C20.2262 17.0216 20.3453 17.0559 20.4496 17.1195L26.666 20.9102C26.7678 20.9723 26.8522 21.0602 26.9107 21.1653C26.9692 21.2704 27 21.3892 27 21.51ZM24.9753 21.51L20.7836 18.954V24.0661L24.9753 21.51ZM26.3125 11.9243H5.6875C5.50516 11.9243 5.3303 11.998 5.20136 12.1291C5.07243 12.2603 5 12.4381 5 12.6236C5 12.8091 5.07243 12.987 5.20136 13.1181C5.3303 13.2493 5.50516 13.323 5.6875 13.323H26.3125C26.4948 13.323 26.6697 13.2493 26.7986 13.1181C26.9276 12.987 27 12.8091 27 12.6236C27 12.4381 26.9276 12.2603 26.7986 12.1291C26.6697 11.998 26.4948 11.9243 26.3125 11.9243Z"
        fill="#BDBDBD"
      />
    </svg>
  ),
  navigationPlaylistActive: () => (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.0567 24.4722C17.0567 24.6576 16.9843 24.8355 16.8554 24.9667C16.7264 25.0978 16.5516 25.1715 16.3692 25.1715H5.6875C5.50516 25.1715 5.3303 25.0978 5.20136 24.9667C5.07243 24.8355 5 24.6576 5 24.4722C5 24.2867 5.07243 24.1088 5.20136 23.9776C5.3303 23.8465 5.50516 23.7728 5.6875 23.7728H16.3692C16.5516 23.7728 16.7264 23.8465 16.8554 23.9776C16.9843 24.1088 17.0567 24.2867 17.0567 24.4722ZM16.3692 17.8485H5.6875C5.50516 17.8485 5.3303 17.9222 5.20136 18.0534C5.07243 18.1845 5 18.3624 5 18.5479C5 18.7334 5.07243 18.9113 5.20136 19.0424C5.3303 19.1736 5.50516 19.2472 5.6875 19.2472H16.3692C16.5516 19.2472 16.7264 19.1736 16.8554 19.0424C16.9843 18.9113 17.0567 18.7334 17.0567 18.5479C17.0567 18.3624 16.9843 18.1845 16.8554 18.0534C16.7264 17.9222 16.5516 17.8485 16.3692 17.8485ZM5.6875 7.3987H26.3125C26.4948 7.3987 26.6697 7.32502 26.7986 7.19386C26.9276 7.06271 27 6.88483 27 6.69935C27 6.51387 26.9276 6.33599 26.7986 6.20483C26.6697 6.07368 26.4948 6 26.3125 6H5.6875C5.50516 6 5.3303 6.07368 5.20136 6.20483C5.07243 6.33599 5 6.51387 5 6.69935C5 6.88483 5.07243 7.06271 5.20136 7.19386C5.3303 7.32502 5.50516 7.3987 5.6875 7.3987ZM27 21.51C27 21.6308 26.9692 21.7496 26.9107 21.8547C26.8522 21.9598 26.7679 22.0477 26.666 22.1098L20.4496 25.9005C20.3453 25.9641 20.2262 25.9984 20.1046 25.9999C19.9829 26.0015 19.8631 25.9701 19.7573 25.9091C19.6514 25.8482 19.5634 25.7597 19.5021 25.6528C19.4409 25.5459 19.4086 25.4244 19.4086 25.3006V17.7194C19.4086 17.5956 19.4409 17.4741 19.5021 17.3672C19.5634 17.2603 19.6514 17.1719 19.7573 17.1109C19.8631 17.0499 19.9829 17.0185 20.1046 17.0201C20.2262 17.0216 20.3453 17.0559 20.4496 17.1195L26.666 20.9102C26.7678 20.9723 26.8522 21.0602 26.9107 21.1653C26.9692 21.2704 27 21.3892 27 21.51ZM24.9753 21.51L20.7836 18.954V24.0661L24.9753 21.51ZM26.3125 11.9243H5.6875C5.50516 11.9243 5.3303 11.998 5.20136 12.1291C5.07243 12.2603 5 12.4381 5 12.6236C5 12.8091 5.07243 12.987 5.20136 13.1181C5.3303 13.2493 5.50516 13.323 5.6875 13.323H26.3125C26.4948 13.323 26.6697 13.2493 26.7986 13.1181C26.9276 12.987 27 12.8091 27 12.6236C27 12.4381 26.9276 12.2603 26.7986 12.1291C26.6697 11.998 26.4948 11.9243 26.3125 11.9243Z"
        fill="#434343"
      />
    </svg>
  ),
  newMenuIcon: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      width="24"
      opacity="0.54"
    >
      <path d="M3 18v-2h18v2Zm0-5v-2h18v2Zm0-5V6h18v2Z" fill="#757575" />
    </svg>
  ),
  newMenuIconGray: () => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24">
      <path d="M3 18v-2h18v2Zm0-5v-2h18v2Zm0-5V6h18v2Z" fill="#333" />
    </svg>
  ),
  newSearchIcon: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      width="24"
      opacity="0.54"
    >
      <path
        d="m19.6 21-6.3-6.3q-.75.6-1.725.95Q10.6 16 9.5 16q-2.725 0-4.612-1.887Q3 12.225 3 9.5q0-2.725 1.888-4.613Q6.775 3 9.5 3t4.613 1.887Q16 6.775 16 9.5q0 1.1-.35 2.075-.35.975-.95 1.725l6.3 6.3ZM9.5 14q1.875 0 3.188-1.312Q14 11.375 14 9.5q0-1.875-1.312-3.188Q11.375 5 9.5 5 7.625 5 6.312 6.312 5 7.625 5 9.5q0 1.875 1.312 3.188Q7.625 14 9.5 14Z"
        fill="#757575"
      />
    </svg>
  ),
  newSearchIconGray: () => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24">
      <path
        d="m19.6 21-6.3-6.3q-.75.6-1.725.95Q10.6 16 9.5 16q-2.725 0-4.612-1.887Q3 12.225 3 9.5q0-2.725 1.888-4.613Q6.775 3 9.5 3t4.613 1.887Q16 6.775 16 9.5q0 1.1-.35 2.075-.35.975-.95 1.725l6.3 6.3ZM9.5 14q1.875 0 3.188-1.312Q14 11.375 14 9.5q0-1.875-1.312-3.188Q11.375 5 9.5 5 7.625 5 6.312 6.312 5 7.625 5 9.5q0 1.875 1.312 3.188Q7.625 14 9.5 14Z"
        fill="#333"
      />
    </svg>
  ),
  newHomeIcon: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      width="24"
      opacity="0.54"
    >
      <path d="M4 21V9l8-6 8 6v12h-6v-7h-4v7Z" fill="#757575" />
    </svg>
  ),
  newHomeIconGray: () => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24">
      <path d="M4 21V9l8-6 8 6v12h-6v-7h-4v7Z" fill="#333" />
    </svg>
  ),
  newUploadIcon: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : '30'}
      height={height ? height : '30'}
      viewBox="0 0 24 24"
    >
      <path
        d="M9 16h2v-3h3v-2h-3V8H9v3H6v2h3Zm-5 4q-.825 0-1.412-.587Q2 18.825 2 18V6q0-.825.588-1.412Q3.175 4 4 4h12q.825 0 1.413.588Q18 5.175 18 6v4.5l4-4v11l-4-4V18q0 .825-.587 1.413Q16.825 20 16 20Z"
        fill="#d80008"
      />
    </svg>
  ),
  checkIcon: ({ width, height, className, fill }) => (
    <svg
      width={width ? width : '30'}
      height={height ? height : '30'}
      className={className}
      fill={fill}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path d="M31.9,6.75a25.4,25.4,0,1,1-18,7.44A25.37,25.37,0,0,1,31.9,6.75Zm14,11.44a19.76,19.76,0,1,0,5.79,14A19.7,19.7,0,0,0,45.88,18.19Z" />
        <path d="M26.24,42.58l-9-9.17c-2.07-2.14.84-5.47,3-3.14l6.08,6.08c2,1.93,1.94,1.72,3.94,0,1-1,7.6-7.59,8.57-8.57L42,24.62c2-2.1,5,.85,2.92,3.2l-5.2,5.23L30.1,42.68l-.29.3a2.13,2.13,0,0,1-3.06.09l-.52-.49Z" />
      </g>
    </svg>
  ),
  pinIcon: ({ width, height, className, fill = '#898989' }) => (
    // <svg
    //   width={width ? width : '18'}
    //   height={height ? height : '18'}
    //   className={className}
    //   fill={fill}
    //   xmlns="http://www.w3.org/2000/svg"
    //   viewBox="0 -960 960 960"
    // >
    //   <path d="m634-448 86 77v60H510v241l-30 30-30-30v-241H240v-60l80-77v-332h-50v-60h414v60h-50v332Zm-313 77h312l-59-55v-354H380v354l-59 55Zm156 0Z" />
    // </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill={fill}
    >
      <g opacity="0.89" clip-path="url(#clip0_39_2230)">
        <path
          d="M15.3144 8.91992C15.0382 8.92374 14.7748 9.0371 14.5822 9.23506C14.3896 9.43303 14.2835 9.6994 14.2872 9.97559C14.2911 10.1231 14.3261 10.2681 14.39 10.4012C15.087 12.2814 15.1564 13.6763 14.7519 14.9603C14.2915 16.3949 13.5462 17.8319 11.8078 19.6286C11.6655 19.7771 11.5701 19.9641 11.5333 20.1664C11.4966 20.3688 11.5202 20.5775 11.6012 20.7665C11.6833 20.9554 11.8196 21.1159 11.9928 21.2275C12.166 21.3391 12.3684 21.3968 12.5744 21.3935L17.3511 21.3147L18.5941 29.0933L19.5797 21.2779L24.3549 21.199C24.4923 21.1973 24.6279 21.1678 24.7535 21.1121C24.8801 21.0578 24.9944 20.98 25.0886 20.8827C25.1828 20.7853 25.2567 20.6685 25.3069 20.5402C25.3832 20.349 25.4009 20.1393 25.3577 19.938C25.3145 19.7367 25.2123 19.5528 25.0643 19.4097C23.2676 17.6714 22.4745 16.2605 21.9813 14.8572C21.5338 13.5879 21.5572 12.1915 22.1924 10.2885C22.2522 10.1539 22.2822 10.0079 22.2804 9.86056C22.275 9.5844 22.1602 9.32168 21.9611 9.13018C21.7621 8.93868 21.4951 8.83408 21.2189 8.83938L15.3144 8.91992Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_39_2230">
          <rect
            width="25"
            height="25"
            fill="white"
            transform="translate(0 18.3501) rotate(-45.9459)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  muteIcon: ({
    width = '24px',
    height = '24px',
    className,
    fill = '#898989',
  }) => (
    <svg
      id="Layer_1"
      fill={fill}
      width={width}
      height={height}
      className={className}
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M39.33,10.59c11.18.83,17.72,8.93,18.09,20.43S51.66,52.17,39.33,53.39V47.65a14.78,14.78,0,0,0,10.51-8.11c2.22-5,2.36-11.39-.46-16.29-2.38-4.12-5-6.18-10-7.22,0-1.47,0-4,0-5.44Zm0,10.75c4.7.56,7.51,4.44,7.63,10.45S44.35,42,39.33,42.39ZM35,10.72c0,6,0,39.46,0,42.69-5.17-4-10.56-8.12-15.9-12.21-3.39,0,.56,0-2.84,0-13.09,0-12.9-18.64,0-18.6h2.82C22,20.49,29.5,14.86,35,10.72Z"
          fill-rule="evenodd"
        />
      </g>
    </svg>
  ),
  unMuteIcon: ({
    width = '24px',
    height = '24px',
    className,
    fill = '#898989',
  }) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill={fill}
      width={width}
      height={height}
      className={className}
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M37.21,53.66v-6a7.81,7.81,0,0,0,5.54-1.84c-3.27-3.21-6.37-6.26-9.7-9.47V53.67c-2.26-2.14-12.81-12.13-14.77-14.09H14.11c-10.3-.16-9.82-15.79,0-15.7h4.17l1.15-1.38C17,19.68,16.84,19.83,14.1,17c-3.37-3.58.86-7.24,4.14-4C33,27.88,39.77,34.27,54.13,49.56,57.24,52.9,53,56.33,50,53.21l-2.66-2.77c-2.9,2.86-6.31,3.23-10.16,3.23Zm0-32.24c3.37.35,9.61,3.59,7.62,12.85-2.06-2.24-4.66-5.11-7.61-8.12C37.22,24.82,37.21,23.1,37.21,21.42Zm0-11.39C45,10,51.45,14.62,54.8,21c3.9,7.48,3.26,17-.53,22.76-1.35-1.36-3.27-3.33-4.59-4.68,4.41-10.68-1-22.07-12.47-23.32V10Zm-4.16-.47v12.7c-1-1-5-5.2-6.69-6.92Z"
          fill-rule="evenodd"
        />
      </g>
    </svg>
  ),
  pinIconSetting: ({
    width = '15px',
    height = '15px',
    className,
    fill = '#898989',
  }) => (
    // <svg
    //   width={width ? width : '18'}
    //   height={height ? height : '18'}
    //   className={className}
    //   fill={fill}
    //   xmlns="http://www.w3.org/2000/svg"
    //   viewBox="0 -960 960 960"
    // >
    //   <path d="m634-448 86 77v60H510v241l-30 30-30-30v-241H240v-60l80-77v-332h-50v-60h414v60h-50v332Zm-313 77h312l-59-55v-354H380v354l-59 55Zm156 0Z" />
    // </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill={fill}
      className={className}
    >
      <path
        d="M13.6967 3.82563L10.365 0.475635C9.73833 -0.154365 8.64583 -0.161032 8.00667 0.470635C7.84333 0.633968 7.715 0.833969 7.65833 0.994802C7.11417 2.1298 6.53 2.84064 5.78 3.2673L5.59917 3.3548C4.7925 3.75897 3.695 4.17064 1.66667 4.17064C1.445 4.17064 1.2325 4.21397 1.02833 4.2973C0.620953 4.46853 0.297142 4.79294 0.126667 5.20063C-0.0392008 5.60801 -0.0392008 6.06409 0.126667 6.47147C0.213333 6.67897 0.335 6.86397 0.489167 7.01397L3.185 9.7098L0 14.1706L4.46 10.9856L7.14917 13.6748C7.30417 13.8323 7.4875 13.9573 7.69583 14.0423C7.89778 14.1273 8.11466 14.171 8.33375 14.171C8.55284 14.171 8.76972 14.1273 8.97167 14.0423C9.17405 13.9602 9.35795 13.8385 9.51253 13.6842C9.6671 13.5299 9.78922 13.3462 9.87167 13.144C9.9575 12.9423 10.0008 12.7215 10.0008 12.504C10.0008 10.474 10.4125 9.3773 10.8158 8.5698C11.2292 7.74313 11.9567 7.11313 13.1108 6.55814C13.3367 6.47147 13.5358 6.3448 13.7033 6.1773C14.0124 5.86355 14.185 5.44048 14.1838 5.0001C14.1825 4.55971 14.0075 4.13763 13.6967 3.82563ZM9.32333 7.82647C8.64083 9.19563 8.33333 10.6348 8.3275 12.4965L1.66667 5.8373C3.44917 5.8373 4.845 5.55814 6.16333 4.93397L6.35917 4.84647C7.525 4.26397 8.41583 3.26897 9.1825 1.65147L12.4525 5.0273C10.9 5.77147 9.90583 6.66063 9.32333 7.82647Z"
        // fill={fill}
      />
    </svg>
  ),
  BlockIcon: ({
    width = '15px',
    height = '15px',
    fill = '#898989',
    onClick,
    className,
  }) => (
    // <svg
    //   fill={fill}
    //   onClick={onClick}
    //   className={className}
    //   width={width}
    //   height={height}
    //   xmlns="http://www.w3.org/2000/svg"
    //   viewBox="0 0 24 24"
    // >
    //   <g id="Layer_2" data-name="Layer 2">
    //     <g id="Layer_1-2" data-name="Layer 1">
    //       <path d="M12,12A6,6,0,1,0,6,6,6,6,0,0,0,12,12ZM12,2A4,4,0,1,1,8,6,4,4,0,0,1,12,2Zm6,10a6,6,0,1,0,6,6A6,6,0,0,0,18,12Zm4,6a4,4,0,0,1-.57,2L16,14.57A4,4,0,0,1,22,18Zm-8,0a4,4,0,0,1,.57-2L20,21.43A4,4,0,0,1,14,18Zm-2,5a1,1,0,0,1-1,1H3a3,3,0,0,1-3-3,7,7,0,0,1,7-7h3a1,1,0,0,1,0,2H7a5,5,0,0,0-5,5,1,1,0,0,0,1,1h8A1,1,0,0,1,12,23Z" />
    //     </g>
    //   </g>
    // </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
      onClick={onClick}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 15 15"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.5 1C5.77609 1 4.12279 1.68482 2.90381 2.90381C1.68482 4.12279 1 5.77609 1 7.5C1 9.22391 1.68482 10.8772 2.90381 12.0962C4.12279 13.3152 5.77609 14 7.5 14C9.22391 14 10.8772 13.3152 12.0962 12.0962C13.3152 10.8772 14 9.22391 14 7.5C14 5.77609 13.3152 4.12279 12.0962 2.90381C10.8772 1.68482 9.22391 1 7.5 1ZM0 7.5C0 5.51088 0.790176 3.60322 2.1967 2.1967C3.60322 0.790176 5.51088 0 7.5 0C9.48912 0 11.3968 0.790176 12.8033 2.1967C14.2098 3.60322 15 5.51088 15 7.5C15 9.48912 14.2098 11.3968 12.8033 12.8033C11.3968 14.2098 9.48912 15 7.5 15C5.51088 15 3.60322 14.2098 2.1967 12.8033C0.790176 11.3968 0 9.48912 0 7.5Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.804 2.19693C12.8978 2.29069 12.9504 2.41785 12.9504 2.55043C12.9504 2.68301 12.8978 2.81017 12.804 2.90393L2.90402 12.8039C2.85789 12.8517 2.80272 12.8898 2.74172 12.916C2.68072 12.9422 2.61511 12.956 2.54872 12.9566C2.48233 12.9571 2.41649 12.9445 2.35504 12.9193C2.29359 12.8942 2.23777 12.8571 2.19082 12.8101C2.14387 12.7632 2.10675 12.7074 2.08161 12.6459C2.05647 12.5845 2.04381 12.5186 2.04439 12.4522C2.04497 12.3858 2.05876 12.3202 2.08497 12.2592C2.11117 12.1982 2.14926 12.1431 2.19702 12.0969L12.097 2.19693C12.1908 2.10319 12.3179 2.05054 12.4505 2.05054C12.5831 2.05054 12.7103 2.10319 12.804 2.19693Z"
        fill={fill}
      />
    </svg>
  ),
  deleteIcon: ({
    width = '17px',
    height = '17px',
    className,
    fill = '#898989',
    onClick,
  }) => (
    <svg
      width={width}
      height={height}
      className={className}
      fill={fill}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -960 960 960"
    >
      <path d="M261-120q-24.75 0-42.375-17.625T201-180v-570h-41v-60h188v-30h264v30h188v60h-41v570q0 24-18 42t-42 18H261Zm438-630H261v570h438v-570ZM367-266h60v-399h-60v399Zm166 0h60v-399h-60v399ZM261-750v570-570Z" />
    </svg>
  ),
  ClearHistoryIcon: ({
    width = '17px',
    height = '17px',
    className,
    fill = '#898989',
    onClick,
  }) => (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 256 256"
      enable-background="new 0 0 256 256"
      width={width}
      height={height}
      className={className}
      fill={fill}
      onClick={onClick}
    >
      <g>
        <g>
          <g>
            <path
              fill={fill}
              d="M223.5,14c-1.1,0.3-3,1.2-4.1,1.9c-1.2,0.7-20.4,19.5-42.7,41.9L136,98.5l-2.1-1.6c-2.7-2.1-5-2.8-8.6-2.8c-3.3,0-4.3,0.5-11.9,5c-15.4,9.1-36.6,14.1-55.5,13.2c-12.5-0.6-22.6-2.4-35.5-6.6c-11-3.5-11.5-3.2-12.2,7.4c-2.2,32.6,12.4,67.4,39.8,94.7c20.7,20.7,44.5,33.3,65.4,34.8c5.7,0.4,12.3-0.5,13.8-1.9c0.8-0.7,4.6-10.8,14.3-38.4c7.2-20.6,15.3-43.5,18-51c4.3-12,4.8-14,4.8-16.8c0-3.7-1.4-7-4.1-9.6l-1.7-1.6L201.7,82c44.2-44.2,43.1-43,44.1-48.9c1.1-7.5-2.8-15-9.5-18.3C233.1,13.3,226.8,12.8,223.5,14z M231.2,22c2.5,0.7,5.2,3.5,6,6.1c0.7,2.4,0.1,5.6-1.5,7.7c-0.5,0.7-19.1,19.2-41.2,41.2l-40.2,40l-6.2-6.2l-6.2-6.2l41.1-41c35.9-35.9,41.3-41.1,43-41.5C228.6,21.3,229,21.3,231.2,22z M128,103.2c2.1,1.4,28.8,28.1,29.6,29.6c0.4,0.8,0.6,1.9,0.4,2.6c-0.6,2.3-8.5,24.7-9,25.2c-0.2,0.3-9.5-8.7-23.9-23c-12.9-12.9-23.3-23.6-23.1-23.7c0.2-0.1,1.6-0.8,3.2-1.4c4.1-1.6,11.7-5.4,15.7-7.9C124.7,102.2,126.2,101.9,128,103.2z M34.9,117.9c17.7,3.7,36.5,3.8,52.7,0.1l4.8-1.1l26.6,26.6l26.6,26.6l-11.1,31.4c-6.1,17.2-11.4,31.6-11.6,32c-0.4,0.5-1.8,0.6-6.6,0.4c-3.3-0.1-6.9-0.5-7.9-0.8c-1.1-0.2-2.7-0.7-3.7-1l-1.8-0.5l1.4-1.8c6.8-8.6,15.9-26.7,16.1-31.8c0-2.4-1.6-4.2-4-4.2c-2.6,0-3.6,1-5,5.4c-2.6,7.9-10.1,21.3-15.5,27.6l-1.4,1.7l-2.6-1.1c-2.9-1.2-11.5-6.1-14.7-8.3l-2-1.4l5.3-5.1c8.3-8,16.7-19.1,16.7-22c0-1.7-2.5-3.9-4.4-3.9c-2.1,0-2.6,0.5-5.2,4.6c-3.1,4.7-8.9,11.5-13.7,16.1c-5.8,5.4-5.7,5.4-9.1,2.5c-1.5-1.3-5.5-4.9-8.7-8.1l-5.9-5.8l5.1-2.4c6.3-3,12.7-6.9,14.9-8.9c2.1-2,2.3-4.5,0.5-6.3c-1.9-1.9-3.6-1.6-8.8,1.7c-5.1,3.4-16,8.7-17.2,8.5c-1-0.2-6.3-7.6-10.2-14c-4.1-6.9-4.4-6.3,2.2-6.6c9.7-0.5,20.8-2.8,22.7-4.7c1.2-1.2,1.2-4.3,0-5.7c-1.1-1.4-3-1.4-10.3,0.2c-4.5,1-7.5,1.3-13.9,1.6l-8.2,0.3l-1.5-3.8c-1.8-4.7-3.7-10.9-4.2-13.3c-0.3-1.8-0.3-1.9,0.8-1.6c8.6,2.1,33.2,1.2,38.3-1.3c2.8-1.4,2.9-5.2,0.3-7.1c-1.2-0.9-1.3-0.9-6.2,0c-6.2,1.1-25.7,1.2-31.5,0.1c-3.5-0.7-3.5-0.7-3.9-2.3c-0.5-2.5-1-14.1-0.7-15.4l0.3-1.2l5.2,1.6C26.8,116,31.7,117.2,34.9,117.9z"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  userShareIcon: ({
    width = '20px',
    height = '20px',
    className,
    fill = '#888888',
    onClick,
  }) => (
    // <svg
    //   width={width ? width : '20'}
    //   height={height ? height : '20'}
    //   className={className}
    //   fill={fill}
    //   xmlns="http://www.w3.org/2000/svg"
    //   data-name="Layer 1"
    //   viewBox="0 0 512 512"
    //   x="0px"
    //   y="0px"
    // >
    //   <g data-name="Group">
    //     <path
    //       data-name="Compound Path"
    //       d="M274.7,201.771A113.788,113.788,0,0,0,202.975,176H166.168C103.592,176,53,227.147,53,289.761V404.538c0,4.419,3.1,8.462,7.523,8.462H211.941c13.87,54,63.227,94.4,121.822,94.4,69.319,0,125.714-56.51,125.714-125.829S403.082,255.8,333.763,255.8a125.948,125.948,0,0,0-21.984,1.827A114.47,114.47,0,0,0,274.7,201.771Zm59.065,69.971A109.714,109.714,0,1,1,224.049,381.456,109.838,109.838,0,0,1,333.763,271.742ZM208.049,381.687A131.033,131.033,0,0,0,208.957,397H69V289.774C69,235.983,112.4,192,166.182,192h36.78a97.883,97.883,0,0,1,93.266,69.509A126.174,126.174,0,0,0,208.049,381.687Z"
    //     />
    //     <path
    //       data-name="Compound Path"
    //       d="M184.42,5a79.8,79.8,0,0,0-79.742,79.793A79.324,79.324,0,0,0,184.452,164h.039l0-7.777.07,8.112A79.693,79.693,0,0,0,240.9,28.242,79.193,79.193,0,0,0,184.457,5Zm.1,16a63.5,63.5,0,1,1,.034,127h-.1a63.5,63.5,0,1,1,.038-127Z"
    //     />
    //     <path
    //       data-name="Compound Path"
    //       d="M282.569,407.306a25.613,25.613,0,0,0,16.513-6.018l36.023,16.52a25.726,25.726,0,1,0,25.481-22.2,25.649,25.649,0,0,0-18.453,7.825l-34.551-15.845a25.638,25.638,0,0,0,.428-9.838l35.252-16.916a25.685,25.685,0,1,0-7.9-13.954L300.81,363.454a25.722,25.722,0,1,0-18.241,43.852Zm78.017,4.3a9.728,9.728,0,1,1-9.728,9.728A9.738,9.738,0,0,1,360.586,411.6Zm0-79.507a9.729,9.729,0,1,1-9.728,9.729A9.739,9.739,0,0,1,360.586,332.1ZM282.569,371.85a9.728,9.728,0,1,1-9.728,9.728A9.738,9.738,0,0,1,282.569,371.85Z"
    //     />
    //   </g>
    // </svg>

    <svg
      width={width}
      height={height}
      fill="none"
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
    >
      <g
        stroke="#888888"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        data-name="Layer 2"
      >
        <path d="M1 29a13 13 0 0 1 16-12.65c.34.08.67.17 1 .28" />
        <circle cx="14" cy="8" r="7" />
        <circle cx="19" cy="23" r="2" />
        <circle cx="27" cy="19" r="2" />
        <path d="m20.8 22.1 4.4-2.2" />
        <circle cx="27" cy="27" r="2" />
        <path d="m25.2 26.1-4.4-2.2" />
      </g>
    </svg>
  ),
  GroupIcon: ({
    width = '17px',
    height = '17px',
    fill = 'rgba(0,0,0,0.3)',
    className = 'nothing',
    onClick,
  }) => (
    <svg
      width={width}
      height={height}
      fill={fill}
      className={className}
      onClick={onClick}
      viewBox="0 0 22 19"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.60776 3.726C7.60776 2.7378 8.00549 1.79008 8.71345 1.09132C9.42142 0.392559 10.3816 0 11.3828 0C12.3841 0 13.3443 0.392559 14.0522 1.09132C14.7602 1.79008 15.1579 2.7378 15.1579 3.726C15.1579 4.71419 14.7602 5.66191 14.0522 6.36067C13.3443 7.05943 12.3841 7.45199 11.3828 7.45199C10.3816 7.45199 9.42142 7.05943 8.71345 6.36067C8.00549 5.66191 7.60776 4.71419 7.60776 3.726ZM15.1579 6.70679C15.1579 5.91624 15.4761 5.15806 16.0425 4.59905C16.6089 4.04004 17.377 3.726 18.178 3.726C18.979 3.726 19.7471 4.04004 20.3135 4.59905C20.8799 5.15806 21.1981 5.91624 21.1981 6.70679C21.1981 7.49735 20.8799 8.25553 20.3135 8.81454C19.7471 9.37354 18.979 9.68759 18.178 9.68759C17.377 9.68759 16.6089 9.37354 16.0425 8.81454C15.4761 8.25553 15.1579 7.49735 15.1579 6.70679ZM1.56763 6.70679C1.56763 5.91624 1.88581 5.15806 2.45218 4.59905C3.01856 4.04004 3.78672 3.726 4.58769 3.726C5.38866 3.726 6.15683 4.04004 6.7232 4.59905C7.28957 5.15806 7.60776 5.91624 7.60776 6.70679C7.60776 7.49735 7.28957 8.25553 6.7232 8.81454C6.15683 9.37354 5.38866 9.68759 4.58769 9.68759C3.78672 9.68759 3.01856 9.37354 2.45218 8.81454C1.88581 8.25553 1.56763 7.49735 1.56763 6.70679ZM5.65478 12.0394C6.26881 11.0896 7.11557 10.3079 8.11676 9.76653C9.11795 9.2252 10.2413 8.94175 11.3828 8.94239C12.339 8.94153 13.2846 9.14 14.1577 9.5248C15.0308 9.90961 15.8116 10.4721 16.4492 11.1754C17.0868 11.8787 17.5667 12.707 17.8575 13.606C18.1483 14.505 18.2435 15.4546 18.1367 16.3924C18.1237 16.5089 18.083 16.6207 18.0179 16.7188C17.9528 16.8169 17.8652 16.8984 17.7622 16.9568C15.8209 18.0562 13.6211 18.6332 11.3828 18.63C9.14459 18.6335 6.94469 18.0565 5.00346 16.9568C4.90046 16.8984 4.81287 16.8169 4.7478 16.7188C4.68273 16.6207 4.64202 16.5089 4.62897 16.3924C4.4599 14.8688 4.82171 13.3339 5.65478 12.0404V12.0394Z"
        // fill="black"
        // fill-opacity="0.3"
      />
      <path
        d="M4.41854 11.1821C3.4257 12.6948 2.96312 14.4871 3.10179 16.2843C2.49728 16.1938 1.90273 16.0474 1.32599 15.8471L1.21022 15.8073C1.10693 15.7712 1.01649 15.7062 0.949842 15.6203C0.883197 15.5344 0.843211 15.4313 0.834728 15.3235L0.824662 15.2032C0.783996 14.7044 0.845556 14.2026 1.00567 13.7278C1.16578 13.2529 1.42116 12.8148 1.75658 12.4395C2.09199 12.0642 2.50056 11.7595 2.95791 11.5435C3.41526 11.3274 3.91202 11.2045 4.41854 11.1821ZM19.6638 16.2843C19.8025 14.4871 19.3399 12.6948 18.3471 11.1821C18.8536 11.2045 19.3504 11.3274 19.8077 11.5435C20.2651 11.7595 20.6736 12.0642 21.009 12.4395C21.3445 12.8148 21.5998 13.2529 21.76 13.7278C21.9201 14.2026 21.9816 14.7044 21.941 15.2032L21.9309 15.3235C21.9222 15.4311 21.8822 15.534 21.8155 15.6197C21.7489 15.7054 21.6585 15.7702 21.5554 15.8063L21.4396 15.8461C20.8688 16.0448 20.2759 16.1928 19.6638 16.2843Z"
        // fill="black"
        // fill-opacity="0.3"
      />
    </svg>
  ),
  PlayIcon: ({
    width = '20px',
    height = '20px',
    fill = '#fff',
    className = 'nothing',
    onClick,
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      version="1.1"
      viewBox="0 0 412.76 497.47"
      fill={fill}
      className={className}
      onClick={onClick}
    >
      <g id="Layer_x0020_1">
        <metadata id="CorelCorpID_0Corel-Layer" />
        <path
          className="fil0"
          d="M87.23 14.22c60.73,39.48 219.75,142.77 301.25,194.72 28.95,18.45 33.83,57.42 4.68,79.03 -91.94,68.18 -203.86,137.2 -300.86,197.98 -41.07,25.73 -89.85,6.83 -90.34,-41.8 -1,-101.08 -1.68,-280.25 -1.95,-385.7 -0.06,-29.11 9.19,-43.06 23.55,-51.65 14.47,-8.64 34.16,-11.78 63.67,7.42z"
        />
      </g>
    </svg>
  ),
  PauseIcon: ({
    width = '20px',
    height = '20px',
    fill = '#ffffff',
    className = 'nothing',
    onClick,
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      version="1.1"
      viewBox="0 0 400.54 493.87"
      fill={fill}
      className={className}
      onClick={onClick}
    >
      <g id="Layer_x0020_1">
        <metadata id="CorelCorpID_0Corel-Layer" />
        <path
          className="fil0"
          d="M-0 72.85c0.03,-97.02 134.9,-97.24 134.4,0 0,116.42 0,232.87 0,349.28 -0.03,99.99 -134.38,90.52 -134.4,0 0,-116.42 0,-232.87 0,-349.28zm266.13 0.24c0.03,-97.02 134.9,-97.24 134.4,0 0,116.42 0,232.87 0,349.28 -0.03,99.99 -134.38,90.52 -134.4,0 0,-116.42 0,-232.87 0,-349.28z"
        />
      </g>
    </svg>
  ),
  PlayIconVideo: ({
    width = '20px',
    height = '20px',
    fill = '#fff',
    className = 'nothing',
    onClick,
  }) => (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      onClick={onClick}
    >
      <path
        d="M16 0C12.8355 0 9.74207 0.938383 7.11088 2.69649C4.4797 4.45459 2.42894 6.95344 1.21793 9.87706C0.00693254 12.8007 -0.309921 16.0177 0.307443 19.1214C0.924806 22.2251 2.44866 25.0761 4.6863 27.3137C6.92394 29.5513 9.77487 31.0752 12.8786 31.6926C15.9823 32.3099 19.1993 31.9931 22.1229 30.7821C25.0466 29.5711 27.5454 27.5203 29.3035 24.8891C31.0616 22.2579 32 19.1645 32 16C32 13.8988 31.5861 11.8183 30.7821 9.87706C29.978 7.93585 28.7994 6.17203 27.3137 4.68629C25.828 3.20055 24.0641 2.022 22.1229 1.21793C20.1817 0.413852 18.1012 0 16 0ZM12.8 23.2V8.8L22.4 16L12.8 23.2Z"
        fill={fill}
      />
    </svg>
  ),
  seenIcon: ({
    width = '16px',
    height = '16px',
    fill = '#004ab6',
    onClick,
    className,
  }) => (
    <svg
      fill={fill}
      onClick={onClick}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2.305,11.235a1,1,0,0,1,1.414.024l3.206,3.319L14.3,7.289A1,1,0,0,1,15.7,8.711l-8.091,8a1,1,0,0,1-.7.289H6.9a1,1,0,0,1-.708-.3L2.281,12.649A1,1,0,0,1,2.305,11.235ZM20.3,7.289l-7.372,7.289-.263-.273a1,1,0,1,0-1.438,1.39l.966,1a1,1,0,0,0,.708.3h.011a1,1,0,0,0,.7-.289l8.091-8A1,1,0,0,0,20.3,7.289Z" />
    </svg>
  ),
  unSeenIcon: ({
    width = '16px',
    height = '16px',
    fill = '#4A5568',
    onClick,
    className,
  }) => (
    <svg
      fill={fill}
      onClick={onClick}
      className={className}
      width={width}
      height={height}
      enable-background="new 0 0 20 20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clip-rule="evenodd"
        d="m15 5c-.28 0-.53.11-.71.29l-6.29 6.3-2.29-2.3c-.18-.18-.43-.29-.71-.29-.55 0-1 .45-1 1 0 .28.11.53.29.71l3 3c.18.18.43.29.71.29s.53-.11.71-.29l7-7c.18-.18.29-.43.29-.71 0-.55-.45-1-1-1z"
        fill-rule="evenodd"
      />
    </svg>
  ),
  GroupOwner: ({
    width = '20px',
    height = '20px',
    className,
    onClick,
    fill = '#838383',
  }) => (
    <svg
      viewBox="0 0 18 15"
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
      onClick={onClick}
      className={className}
      width={width}
      height={height}
    >
      <path
        d="M9 3.75L12 8.625L15 6.09375L14.3 9.375H3.7L3 6.09375L6 8.625L9 3.75ZM9 0L5.5 5.625L0 0.9375L2 11.25H16L18 0.9375L12.5 5.625L9 0ZM16 13.125H2V14.0625C2 14.625 2.4 15 3 15H15C15.6 15 16 14.625 16 14.0625V13.125Z"
        fill="black"
      />
    </svg>
  ),
  EditIcon: ({
    width = '20px',
    height = '20px',
    className,
    onClick,
    fill = 'rgba(0,0,0,0.54)',
  }) => (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width={width}
    //   height={height}
    //   version="1.1"
    //   viewBox="0 0 457.53 459.3"
    //   fill={fill}
    //   onClick={onClick}
    //   className={className}
    // >
    //   <g id="Layer_x0020_1">
    //     <metadata id="CorelCorpID_0Corel-Layer" />
    //     <path
    //       class="fil0"
    //       d="M382.27 171.17c-146.72,146.68 -136.87,136.97 -281.19,281.22 -2.84,2.84 -3.51,3.67 -9.55,3.87 -35.87,1.2 -45.99,2.25 -74.12,3.03 -12.17,0.33 -17.3,-5.59 -17.38,-17.43 -0.19,-24.85 1.67,-58.12 1.71,-75.39 0,-3.47 1.57,-7.3 3.77,-9.67 166.82,-166.01 114.48,-115.27 281.3,-281.28 35.55,35.78 57.47,57.69 95.47,95.66z"
    //     />
    //     <path
    //       class="fil0"
    //       d="M451.49 101.65c-10.89,10.93 -26.83,26.57 -48.5,48.48 -27.5,-27.66 -72.68,-72.7 -95.83,-95.88 38.65,-38.46 12.03,-11.69 50.67,-50.15 7.07,-6.68 17.62,-4.34 22.99,0.9 20.48,20.55 50.67,50.67 71.24,71.24 8.84,8.84 5.68,19.33 -0.58,25.41z"
    //     />
    //   </g>
    // </svg>

    <svg
      width={width}
      height={height}
      fill={fill}
      onClick={onClick}
      className={className}
      viewBox="0 0 15 15"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0.416667 14.8692H14.5C14.6105 14.8692 14.7165 14.8253 14.7946 14.7472C14.8728 14.669 14.9167 14.563 14.9167 14.4525C14.9167 14.342 14.8728 14.2361 14.7946 14.1579C14.7165 14.0798 14.6105 14.0359 14.5 14.0359H0.416667C0.30616 14.0359 0.200179 14.0798 0.122039 14.1579C0.0438986 14.2361 0 14.342 0 14.4525C0 14.563 0.0438986 14.669 0.122039 14.7472C0.200179 14.8253 0.30616 14.8692 0.416667 14.8692ZM5.55167 11.7375C5.90367 11.639 6.22484 11.4526 6.485 11.1959L14.435 3.24587C14.7073 2.97255 14.8601 2.60249 14.8601 2.21671C14.8601 1.83093 14.7073 1.46087 14.435 1.18754L13.6517 0.412542C13.3745 0.147754 13.0059 0 12.6225 0C12.2391 0 11.8705 0.147754 11.5933 0.412542L3.64333 8.35421C3.38612 8.61266 3.20208 8.93473 3.11 9.28754L2.49333 11.5875C2.46408 11.6926 2.46332 11.8036 2.49115 11.909C2.51898 12.0145 2.57438 12.1106 2.65167 12.1875C2.76962 12.3035 2.92794 12.3692 3.09333 12.3709L5.55167 11.7375ZM5.89333 10.6042C5.73971 10.7606 5.54687 10.8729 5.335 10.9292L4.52667 11.1459L3.69333 10.3125L3.91 9.50421C3.96829 9.29315 4.08026 9.10079 4.235 8.94588L4.55167 8.63754L6.21 10.2959L5.89333 10.6042ZM6.80167 9.70421L5.14333 8.04587L10.7517 2.43754L12.41 4.09588L6.80167 9.70421ZM13.8433 2.66254L13.0017 3.50421L11.3433 1.84588L12.185 0.995875C12.2429 0.937722 12.3117 0.891579 12.3875 0.860093C12.4633 0.828608 12.5446 0.8124 12.6267 0.8124C12.7087 0.8124 12.79 0.828608 12.8658 0.860093C12.9416 0.891579 13.0104 0.937722 13.0683 0.995875L13.8433 1.77921C13.9596 1.89682 14.0247 2.05552 14.0247 2.22088C14.0247 2.38623 13.9596 2.54493 13.8433 2.66254Z" />
    </svg>
  ),
  UploadImageIcon: ({
    width = '20px',
    height = '20px',
    className,
    onClick,
    fill = '#838383',
  }) => (
    <svg
      fill={fill}
      className={className}
      onClick={onClick}
      width={width}
      height={height}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path d="M29.27,8.16,17.69,20c-2.66,2.76,1.08,6.27,3.89,3.27l7.83-7.84V40a2.54,2.54,0,1,0,5.07,0V15.39l7.84,7.84c2.59,2.71,6.27-.55,3.58-3.58L34.25,8l-.38-.38a2.74,2.74,0,0,0-3.93-.12C29.73,7.71,29.51,7.92,29.27,8.16ZM13.92,57.58h-.06A5.78,5.78,0,0,1,9.68,55.8,5.78,5.78,0,0,1,7.9,51.62v-9.1a2.31,2.31,0,1,1,4.59,0v8.83c0,1.25.61,1.62,1.41,1.63H50a1.51,1.51,0,0,0,1.47-1.68V42.52a2.31,2.31,0,1,1,4.59,0v9a6,6,0,0,1-6,6Z" />
      </g>
    </svg>
  ),
  DeleteIcon: ({
    width = '20px',
    height = '20px',
    className,
    onClick,
    fill = '#838383',
  }) => (
    <svg
      fill={fill}
      className={className}
      onClick={onClick}
      width={width}
      height={height}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M48.31,21.73c0,11.55,0,20.47,0,32,0,2.47-1.52,3.68-3.17,3.7-9.7,0-16.33,0-26,0a3.31,3.31,0,0,1-3.45-3.32c0-13.12.05-19.9.09-33a4.13,4.13,0,0,1,4.07-3.83c7,0,17.72,0,24.72,0,3,0,3.77,2.4,3.73,4.49Z"
          fill-rule="evenodd"
        />
        <path
          d="M48.16,14.81c-11.79,0-20.59,0-32.37,0a2.82,2.82,0,0,1-2.95-3,2.94,2.94,0,0,1,2.95-3l7.88,0c.31-.33,1.12-1.18,1.66-1.72a.87.87,0,0,1,.75-.29c3.26,0,7.77,0,11,0a1.24,1.24,0,0,1,1,.46c.47.54.94,1.1,1.31,1.54h8.81c3.76,0,3.78,5.92,0,6Z"
          fill-rule="evenodd"
        />
      </g>
    </svg>
  ),
  AdminIcon: ({
    width = '20px',
    height = '20px',
    className,
    onClick,
    fill = '#838383',
  }) => (
    <svg
      fill={fill}
      className={className}
      onClick={onClick}
      width={width}
      height={height}
      class="svg-icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M512 568.889c-159.289 0-284.444-125.156-284.444-284.445S352.71 0 512 0s284.444 125.156 284.444 284.444S671.29 568.89 512 568.89zM512 512c125.156 0 227.556-102.4 227.556-227.556S637.156 56.89 512 56.89s-227.556 102.4-227.556 227.555S386.844 512 512 512z m312.889 512c-79.645 0-142.222-62.578-142.222-142.222s62.577-142.222 142.222-142.222S967.11 802.133 967.11 881.778 904.533 1024 824.89 1024z m0-56.889c45.511 0 85.333-39.822 85.333-85.333s-39.822-85.334-85.333-85.334-85.333 39.823-85.333 85.334 39.822 85.333 85.333 85.333zM796.444 455.111h56.89v284.445h-56.89z m56.89 0H967.11V512H853.333z m0 113.778H967.11v56.889H853.333z" />
      <path d="M512 512l-51.2 62.578C261.689 597.333 113.778 762.31 113.778 967.11h-56.89v-56.889h5.69C91.022 688.356 278.756 512 512 512z m0 0l-51.2 62.578C261.689 597.333 113.778 762.31 113.778 967.11h-56.89v-56.889h5.69C91.022 688.356 278.756 512 512 512z" />
    </svg>
  ),
  checkIcon: ({
    width = '20px',
    height = '20px',
    className,
    onClick,
    fill = '#838383',
  }) => (
    <svg
      fill={fill}
      className={className}
      onClick={onClick}
      width={width}
      height={height}
      viewBox="0 0 11 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.39573 6.46515L1.11748 4.25751C0.994714 4.13855 0.828213 4.07173 0.654602 4.07173C0.480991 4.07173 0.31449 4.13855 0.191728 4.25751C0.0689668 4.37647 0 4.53781 0 4.70604C0 4.78934 0.0169319 4.87182 0.0498287 4.94878C0.0827256 5.02574 0.130943 5.09566 0.191728 5.15456L2.93614 7.81391C3.1922 8.06203 3.60583 8.06203 3.86189 7.81391L10.8083 1.08284C10.931 0.963881 11 0.802542 11 0.634312C11 0.466082 10.931 0.304742 10.8083 0.185786C10.6855 0.0668292 10.519 0 10.3454 0C10.1718 0 10.0053 0.0668292 9.88253 0.185786L3.39573 6.46515Z"
        fill="black"
      />
    </svg>

    // <svg
    //   fill={fill}
    //   className={className}
    //   onClick={onClick}
    //   width={width}
    //   height={height}
    //   class="svg-icon"
    //   viewBox="0 0 1024 1024"
    //   version="1.1"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path d="M512 568.889c-159.289 0-284.444-125.156-284.444-284.445S352.71 0 512 0s284.444 125.156 284.444 284.444S671.29 568.89 512 568.89zM512 512c125.156 0 227.556-102.4 227.556-227.556S637.156 56.89 512 56.89s-227.556 102.4-227.556 227.555S386.844 512 512 512z m312.889 512c-79.645 0-142.222-62.578-142.222-142.222s62.577-142.222 142.222-142.222S967.11 802.133 967.11 881.778 904.533 1024 824.89 1024z m0-56.889c45.511 0 85.333-39.822 85.333-85.333s-39.822-85.334-85.333-85.334-85.333 39.823-85.333 85.334 39.822 85.333 85.333 85.333zM796.444 455.111h56.89v284.445h-56.89z m56.89 0H967.11V512H853.333z m0 113.778H967.11v56.889H853.333z" />
    //   <path d="M512 512l-51.2 62.578C261.689 597.333 113.778 762.31 113.778 967.11h-56.89v-56.889h5.69C91.022 688.356 278.756 512 512 512z m0 0l-51.2 62.578C261.689 597.333 113.778 762.31 113.778 967.11h-56.89v-56.889h5.69C91.022 688.356 278.756 512 512 512z" />
    // </svg>
  ),
  copyIcon: ({
    width = '20px',
    height = '20px',
    className,
    onClick,
    fill = '#838383',
  }) => (
    <svg
      fill={fill}
      className={className}
      onClick={onClick}
      width={width}
      height={height}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path d="M23.8,14.38h0a3.9,3.9,0,0,0-3.8,3.8h0V53.77h0a3.9,3.9,0,0,0,3.8,3.8H47.64a3.9,3.9,0,0,0,3.8-3.8h0V18.19a3.91,3.91,0,0,0-3.81-3.81ZM47.62,20.1V52.25a1.56,1.56,0,0,1-1.48,1.51h-21a1.56,1.56,0,0,1-1.51-1.51q0-16,.1-32.14a1.44,1.44,0,0,1,1.4-1.44l21-.11a1.35,1.35,0,0,1,1.46,1.54ZM16.18,6.75h0a3.69,3.69,0,0,0-2.66,1.14,3.69,3.69,0,0,0-1.14,2.66h0V44.27a1.91,1.91,0,1,0,3.81,0V13.55a2.86,2.86,0,0,1,2.77-3H39.27a1.91,1.91,0,1,0,0-3.81Z" />
      </g>
    </svg>
  ),
  emojiIcon: ({
    width = '20px',
    height = '20px',
    className,
    onClick,
    fill = '#838383',
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      id="smiley"
    >
      <path
        fill={fill}
        d="M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7zm0-1C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8z"
      ></path>
      <path
        fill={fill}
        d="M8 13.2c-2 0-3.8-1.2-4.6-3.1l.9-.4c.6 1.5 2.1 2.4 3.7 2.4s3.1-1 3.7-2.4l.9.4c-.8 2-2.6 3.1-4.6 3.1zM7 6a1 1 0 11-2 0 1 1 0 012 0zM11 6a1 1 0 11-2 0 1 1 0 012 0z"
      ></path>
    </svg>
  ),
  webcamIcon: ({
    width = '20px',
    height = '20px',
    className,
    onClick,
    fill = '#838383',
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
      className={className}
      onClick={onClick}
      width={width}
      height={height}
      viewBox="0 -960 960 960"
    >
      <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h480q33 0 56.5 23.5T720-720v180l160-160v440L720-420v180q0 33-23.5 56.5T640-160H160Zm0-80h480v-480H160v480Zm0 0v-480 480Z" />
    </svg>
  ),
};

export default AppIcons;
